import React from 'react';
import {
    Tooltip,
    OverlayTrigger,
    Grid,
    Row,
    Col
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select';
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import ToggleButton from "react-toggle-button";
import { themeCSSConstants } from 'redux/constant/themeCSS';
import CreatableSelect from 'react-select';
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from 'react-redux';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import DatePicker from 'react-date-picker';
import { brandActions } from '../../../redux/actions/brand-actions';
import { MdClose } from 'react-icons/md'
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { withRouter } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi'
import { Rules } from '../../../constants/TransformationRulesConstants';
import LookupFilter from './TrasformationLookupFilter';
import { IoMdAdd } from 'react-icons/io'
import $ from 'jquery';
let _ = require('lodash');
var cloneDeep = require('lodash.clonedeep');

const components = {
    DropdownIndicator: null,
};

const createOption = (label) => ({
    label,
    value: label,
});

function makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
class TransformationRulesForm extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
        this.state = {
            submitted: false,
            formType: 'add',
            rule_filters: [],
            duplicate_error: {},
            target_attribute: {
                ...OC.TARGET_ATTRIBUTE,
            },
            base_target_attribute: {
                ...OC.BASE_TARGET_ATTRIBUTE
            },
            target_attribute_data_type: '',
            inputValue: '',
            value: [],
            startDate: null,
            date: null,
            lookupTable: null,
            lookupAttributes: null,
            disableAddFilter: false,
            paren_unequal: false,
            totalParen: false,
            operand_one_lookup: false,
            operand_two_lookup: false,
            operand_one_lookup_expression: [],
            operand_two_lookup_expression: [],
            concatAdditionalFields: [{ ...OC.CONCAT_OBJ }],
            attributesLookup: null,
        };
        this.handleListSubmitForm = this.handleListSubmitForm.bind(this);
    }

    popupHandler = (index) => {
        const rule_filters = this.state.rule_filters;
        const updated_filter = rule_filters[index];
        updated_filter['popupHandler'] = true;
        this.setState({
            rule_filters: rule_filters
        })
    }

    closeHandler = (event, index) => {
        event.stopPropagation();
        const rule_filters = this.state.rule_filters;
        const updated_filter = rule_filters[index];
        updated_filter['popupHandler'] = false;
        this.setState({
            rule_filters: rule_filters
        })
    }

    //React-select dropdown function in case of rule_filters
    handleDropdown = (index, selectedOption, name) => {
        if (name.action === 'select-option') {
            if (name.name === 'operator') {
                if (this.state.rule_filters[index].operator_category === Rules.DATETIME) {
                    if (selectedOption.value === 'between' || selectedOption.value !== 'between') {
                        const rule_filters = this.state.rule_filters;
                        const updated_filter = rule_filters[index];
                        updated_filter['date'];
                        updated_filter['param_type'] = 'static'
                        this.setState({
                            rule_filters: rule_filters
                        })
                    }
                    else {
                    }
                }
                else if (this.state.rule_filters[index].operator_category !== Rules.DATETIME) {
                    if (selectedOption.value !== this.state.rule_filters[index].operator) {
                        const rule_filters = this.state.rule_filters;
                        const updated_filter = rule_filters[index];
                        updated_filter['date'] = null;
                        updated_filter['param_static_value'] = [];
                        updated_filter['static_single_value'] = '';
                        updated_filter['param_field_id'] = '';
                        updated_filter['param_field'] = '';
                        updated_filter['param_field_title'] = '';
                        this.setState({
                            rule_filters: rule_filters
                        })
                    }
                    else {
                    }
                }
            }
            if (name.name === 'operand_attribute') {
                const atts = cloneDeep(this.state.rule_filters);
                atts[index][name.name] = selectedOption.db_column;
                atts[index][name.name + '_id'] = selectedOption.id;
                atts[index][name.name + '_title'] = selectedOption.title;
                atts[index]['operator_category'] = selectedOption.data_type;
                atts[index]['operator'] = '';
                this.setState({ rule_filters: atts }, () => {
                    if (this.state.rule_filters[index].operator_category !== Rules.DATETIME) {
                        const rule_filters = this.state.rule_filters;
                        const updated_filter = rule_filters[index];
                        updated_filter['date'] = null;
                        this.setState({
                            rule_filters: rule_filters
                        })
                    }
                });
            }
            else if (name.name === 'param_field') {
                const atts = [...this.state.rule_filters];
                const updatedfilter = atts[index];
                updatedfilter[name.name] = selectedOption.db_column;
                updatedfilter[name.name + '_id'] = selectedOption.id;
                updatedfilter[name.name + '_title'] = selectedOption.title;
                this.setState({ rule_filters: atts });
            }
            else if (name.name === 'param_lookup_table' || name.name === 'param_lookup_table_column') {
                const rule_filters = this.state.rule_filters;
                const updated_filter = rule_filters[index];
                if (name.name === 'param_lookup_table') {
                    updated_filter[name.name] = selectedOption.table_name;
                }
                else if (name.name === 'param_lookup_table_column') {
                    updated_filter[name.name] = selectedOption.db_column;
                    updated_filter[name.name + '_title'] = selectedOption.title;
                }
                updated_filter['param_static_value'] = [];
                updated_filter['static_single_value'] = '';
                updated_filter['param_field_id'] = '';
                updated_filter['param_field_title'] = '';
                updated_filter['param_field'] = '';
                this.setState({
                    rule_filters: rule_filters
                })
            }
            else {
                const atts = cloneDeep(this.state.rule_filters);
                atts[index][name.name] = selectedOption.value;
                this.setState({ rule_filters: atts }, () => {
                    if (name.name === 'param_type') {
                        if (selectedOption.value === 'field' ) {
                            const atts = cloneDeep(this.state.rule_filters);
                            atts[index]['param_static_value'] = [];
                            atts[index]['static_single_value'] = '';
                            atts[index]['param_lookup_table_column'] = '';
                            atts[index]['param_lookup_table_column_title'] = '';
                            atts[index]['param_lookup_table'] = '';
                            this.setState({ rule_filters: atts })
                        }
                        if (selectedOption.value === 'static') {
                            const atts = cloneDeep(this.state.rule_filters);
                            atts[index]['param_field'] = '';
                            atts[index]['param_field_id'] = '';
                            atts[index]['param_field_title'] = '';
                            atts[index]['param_lookup_table_column'] = '';
                            atts[index]['param_lookup_table_title'] = '';
                            atts[index]['param_lookup_table'] = '';
                            this.setState({ rule_filters: atts })
                        }
                    }
                    if (name.name === 'logical_operator') {
                        if (selectedOption.value === 'none') {
                            const rule_filters = this.state.rule_filters;
                            const newArray = rule_filters.splice(0, index + 1)
                            this.setState({
                                rule_filters: newArray,
                                disableAddFilter: true
                            })
                        }
                        else if (selectedOption.value === 'or' || selectedOption.value === 'and') {
                            this.setState({
                                disableAddFilter: false
                            })
                        }
                        else {

                        }
                    }
                });
            }
        }
    }

    // target dropdown handles all the cases of set actions
    handleTargetDropdown = (selectedOption, name) => {

     //  console.log('waseem1', selectedOption, name)
        if (name.action === 'select-option') {
            if (name.name === Rules.OPERAND_ONE_ACTION) {
                this.setState({
                    target_attribute: {
                        ...OC.TARGET_ATTRIBUTE,
                        [name.name]: selectedOption.value
                    }
                }, () => {
                })
            }
            else if (name.name === Rules.OPERAND_ONE_VALUE_FIELD) {
                this.setState({
                    target_attribute: {
                        ...this.state.target_attribute,
                        [name.name]: selectedOption.db_column,
                        [name.name + '_title']: selectedOption.title,
                        [name.name + '_id']: selectedOption.id
                    }
                })
            }
          //   else if (name.name === 'concatby') {
          // // alert(selectedOption.title)
          //       this.setState({
          //           target_attribute: {
          //               ...this.state.target_attribute,
          //               [name.name]: 'nodb',
          //               [Rules.OPERAND_ONE_VALUE_FIELD + '_title']: selectedOption.title,
          //               [Rules.OPERAND_ONE_VALUE_FIELD + '_id']: selectedOption.id
          //           }
          //       })
          //       //console.log(this.state.target_attribute)
          //   }
            else if (name.name.includes('lookup')) {
                if (name.name.includes('column')) {
                    this.setState({
                        target_attribute: {
                            ...this.state.target_attribute,
                            [name.name]: selectedOption.db_column,
                            [name.name + '_title']: selectedOption.title,
                        }
                    })
                } else {
                    this.setState({
                        target_attribute: {
                            ...this.state.target_attribute,
                            [name.name]: selectedOption.table_name,
                        }
                    })
                }
            }
            else if (selectedOption.title) {
                this.setState({
                    target_attribute: {
                        ...this.state.target_attribute,
                        [name.name]: selectedOption.db_column,
                        [name.name + '_title']: selectedOption.title,
                        [name.name + '_id']: selectedOption.id
                    }
                })
            }
            else {
                this.setState({
                    target_attribute: {
                        ...this.state.target_attribute,
                        [name.name]: selectedOption.value,
                    }
                }, () => {
                    if (name.name === Rules.OPERAND_ONE_VALUE_TYPE) {
                        if (selectedOption.value !== '') {
                            // if (selectedOption.value !== this.state.target_attribute.value_type) {
                            this.setState({
                                target_attribute: {
                                    ...this.state.target_attribute,
                                    [Rules.OPERAND_ONE_ACTION]: this.state.target_attribute[Rules.OPERAND_ONE_ACTION],
                                    [Rules.OPERAND_ONE_VALUE_TYPE]: this.state.target_attribute[Rules.OPERAND_ONE_VALUE_TYPE],
                                    [Rules.OPERAND_ONE_VALUE_FIELD]: '',
                                    [Rules.OPERAND_ONE_VALUE_FIELD_TITLE]: '',
                                    [Rules.OPERAND_ONE_VALUE_FIELD_ID]: '',
                                    [Rules.OPERAND_ONE_VALUE_STATIC]: '',
                                    [Rules.OPERAND_ONE_LOOKUP_TABLE]: '',
                                    [Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN]: '',
                                    [Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN_TITLE]: '',
                                    [Rules.SET_VALUE_ACTION]: '',
                                    [Rules.SET_REPLACE_STRING]: '',
                                }
                            })
                            // }
                            return;
                        }
                        if (selectedOption.value === 'field' ) {

                            this.setState({
                                target_attribute: {
                                    ...this.state.target_attribute,
                                    [Rules.OPERAND_ONE_VALUE_STATIC]: ''
                                }
                            })
                        }
                        if (selectedOption.value === 'static') {


                            this.setState({
                                target_attribute: {
                                    ...this.state.target_attribute,
                                    [Rules.OPERAND_ONE_VALUE_FIELD]: '',
                                    [Rules.OPERAND_ONE_VALUE_FIELD_TITLE]: '',
                                    [Rules.OPERAND_ONE_VALUE_FIELD_ID]: ''
                                }
                            })
                        }

                    }
                })
            }

            if (name.name === Rules.OPERAND_ONE_VALUE_TYPE || name.name === Rules.OPERAND_TWO_VALUE_TYPE) {
                if (this.state.target_attribute[Rules.OPERAND_ONE_ACTION] === 'replace') {
                    if (name.name === Rules.OPERAND_ONE_VALUE_TYPE) {
                        this.setState({
                            target_attribute: {
                                ...this.state.target_attribute,
                                [Rules.OPERAND_ONE_VALUE_TYPE]: selectedOption.value,
                                [Rules.OPERAND_ONE_VALUE_FIELD]: '',
                                [Rules.OPERAND_ONE_VALUE_FIELD_TITLE]: '',
                                [Rules.OPERAND_ONE_VALUE_FIELD_ID]: '',
                                [Rules.OPERAND_ONE_LOOKUP_TABLE]: '',
                                [Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN]: '',
                                [Rules.OPERAND_ONE_VALUE_STATIC]: '',
                            }
                        })
                    }
                    else if (name.name === Rules.OPERAND_TWO_VALUE_TYPE) {
                        // if (selectedOption.value !== 'static') {
                        this.setState({
                            target_attribute: {
                                ...this.state.target_attribute,
                                [Rules.OPERAND_TWO_VALUE_TYPE]: selectedOption.value,
                                [Rules.OPERAND_TWO_VALUE_FIELD]: '',
                                [Rules.OPERAND_TWO_VALUE_FIELD_TITLE]: '',
                                [Rules.OPERAND_TWO_VALUE_FIELD_ID]: '',
                                [Rules.OPERAND_TWO_LOOKUP_TABLE]: '',
                                [Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN]: '',
                                [Rules.OPERAND_TWO_VALUE_STATIC]: '',
                                [Rules.SET_REPLACE_STRING]: '',
                            }
                        })
                        // }
                    }
                }
            }

            if (this.state.target_attribute[Rules.OPERAND_ONE_ACTION] === 'multiply' || this.state.target_attribute[Rules.OPERAND_ONE_ACTION] === 'divide' || this.state.target_attribute[Rules.OPERAND_ONE_ACTION] === 'add' || this.state.target_attribute[Rules.OPERAND_ONE_ACTION] === 'subtract') {
                if (name.name === Rules.OPERAND_ONE_VALUE_TYPE) {
                    this.setState({
                        target_attribute: {
                            ...this.state.target_attribute,
                            [Rules.OPERAND_ONE_VALUE_TYPE]: selectedOption.value,
                            [Rules.OPERAND_ONE_VALUE_FIELD]: '',
                            [Rules.OPERAND_ONE_VALUE_FIELD_TITLE]: '',
                            [Rules.OPERAND_ONE_VALUE_FIELD_ID]: '',
                            [Rules.OPERAND_ONE_VALUE_STATIC]: '',
                        }
                    })
                }
                else if (name.name === Rules.OPERAND_TWO_VALUE_TYPE) {
                    this.setState({
                        target_attribute: {
                            ...this.state.target_attribute,
                            [Rules.OPERAND_TWO_VALUE_TYPE]: selectedOption.value,
                            [Rules.OPERAND_TWO_VALUE_FIELD]: '',
                            [Rules.OPERAND_TWO_VALUE_FIELD_TITLE]: '',
                            [Rules.OPERAND_TWO_VALUE_FIELD_ID]: '',
                            [Rules.OPERAND_TWO_VALUE_STATIC]: '',
                        }
                    })
                }
            }
        }
    }

    // Base target dropdown handles the 2nd operand in the URL case.
    handleBaseTargetDropdown = (selectedOption, name) => {

        if (name.action === 'select-option' && name.name.includes('two')) {
            if (name.name === Rules.OPERAND_TWO_ACTION) {
                this.setState({
                    base_target_attribute: {
                        ...OC.BASE_TARGET_ATTRIBUTE,
                        [Rules.OPERAND_TWO_ACTION]: selectedOption.value
                    }
                })
            }

            else if (name.name === Rules.OPERAND_TWO_VALUE_FIELD) {
                this.setState({
                    base_target_attribute: {
                        ...this.state.base_target_attribute,
                        [name.name]: selectedOption.db_column,
                        [name.name + '_title']: selectedOption.title,
                        [name.name + '_id']: selectedOption.id
                    }
                })
            }
            else if (name.name.includes('lookup')) {
                if (name.name.includes('column')) {
                    this.setState({
                        base_target_attribute: {
                            ...this.state.base_target_attribute,
                            [name.name]: selectedOption.db_column,
                            [name.name + '_title']: selectedOption.title,
                        }
                    })
                } else {
                    this.setState({
                        base_target_attribute: {
                            ...this.state.base_target_attribute,
                            [name.name]: selectedOption.table_name,
                        }
                    })
                }
            }
            else if (selectedOption.title) {
                this.setState({
                    base_target_attribute: {
                        ...this.state.base_target_attribute,
                        [name.name]: selectedOption.db_column,
                        [name.name + '_title']: selectedOption.title,
                        [name.name + '_id']: selectedOption.id
                    }
                })
            }
            else {
                this.setState({
                    base_target_attribute: {
                        ...this.state.base_target_attribute,
                        [name.name]: selectedOption.value,
                    }
                }, () => {
                    if (name.name === Rules.OPERAND_TWO_VALUE_TYPE) {
                        if (selectedOption.value !== '') {
                            // if (selectedOption.value !== this.state.target_attribute.value_type) {
                            this.setState({
                                base_target_attribute: {
                                    ...OC.BASE_TARGET_ATTRIBUTE,
                                    [Rules.OPERAND_TWO_ACTION]: this.state.base_target_attribute[Rules.OPERAND_TWO_ACTION],
                                    [Rules.OPERAND_TWO_VALUE_TYPE]: this.state.base_target_attribute[Rules.OPERAND_TWO_VALUE_TYPE],
                                }
                            })
                            // }
                            return;
                        }
                        if (selectedOption.value === 'field') {
                            this.setState({
                                base_target_attribute: {
                                    ...this.state.base_target_attribute,
                                    [Rules.OPERAND_TWO_VALUE_STATIC]: ''
                                }
                            })
                        }
                        if (selectedOption.value === 'static') {
                            this.setState({
                                base_target_attribute: {
                                    ...this.state.base_target_attribute,
                                    [Rules.OPERAND_TWO_VALUE_FIELD]: '',
                                    [Rules.OPERAND_TWO_VALUE_FIELD_TITLE]: '',
                                    [Rules.OPERAND_TWO_VALUE_FIELD_ID]: ''
                                }
                            })
                        }
                    }
                })
            }
        }
        else {
            if (name.action === 'select-option') {
                if (name.name === Rules.OPERAND_ONE_ACTION) {
                    this.setState({
                        target_attribute: {
                            ...OC.TARGET_ATTRIBUTE,
                            [name.name]: selectedOption.value
                        }
                    })
                }
                else if (name.name === Rules.OPERAND_ONE_VALUE_FIELD) {
                    this.setState({
                        target_attribute: {
                            ...this.state.target_attribute,
                            [name.name]: selectedOption.db_column,
                            [name.name + '_title']: selectedOption.title,
                            [name.name + '_id']: selectedOption.id
                        }
                    })
                }
                else if (name.name.includes('lookup')) {
                    if (name.name.includes('column')) {
                        this.setState({
                            target_attribute: {
                                ...this.state.target_attribute,
                                [name.name]: selectedOption.db_column,
                                [name.name + '_title']: selectedOption.title,
                                [name.name + '_title']: selectedOption.title,
                            }
                        })
                    } else {
                        this.setState({
                            target_attribute: {
                                ...this.state.target_attribute,
                                [name.name]: selectedOption.table_name,
                            }
                        })
                    }
                }
                else if (selectedOption.title) {
                    this.setState({
                        target_attribute: {
                            ...this.state.target_attribute,
                            [name.name]: selectedOption.db_column,
                            [name.name + '_title']: selectedOption.title,
                            [name.name + '_id']: selectedOption.id
                        }
                    })
                }
                else {
                    this.setState({
                        target_attribute: {
                            ...this.state.target_attribute,
                            [name.name]: selectedOption.value,
                        }
                    }, () => {
                        if (name.name === Rules.OPERAND_ONE_VALUE_TYPE) {
                            if (selectedOption.value !== '') {
                                // if (selectedOption.value !== this.state.target_attribute.value_type) {
                                this.setState({
                                    target_attribute: {
                                        ...OC.TARGET_ATTRIBUTE,
                                        [Rules.OPERAND_ONE_ACTION]: this.state.target_attribute[Rules.OPERAND_ONE_ACTION],
                                        [Rules.OPERAND_ONE_VALUE_TYPE]: this.state.target_attribute[Rules.OPERAND_ONE_VALUE_TYPE],
                                    }
                                })
                                // }
                                return;
                            }
                            if (selectedOption.value === 'field') {
                                this.setState({
                                    target_attribute: {
                                        ...this.state.target_attribute,
                                        [Rules.OPERAND_ONE_VALUE_TYPE]: ''
                                    }
                                })
                            }
                            if (selectedOption.value === 'static') {
                                this.setState({
                                    target_attribute: {
                                        ...this.state.target_attribute,
                                        [Rules.OPERAND_ONE_VALUE_FIELD]: '',
                                        [Rules.OPERAND_ONE_VALUE_FIELD_TITLE]: '',
                                        [Rules.OPERAND_ONE_VALUE_FIELD_TITLE]: '',
                                        [Rules.OPERAND_ONE_VALUE_FIELD_ID]: ''
                                    }
                                })
                            }
                        }
                    })
                }
            }
        }
    }

    handleAdditionalConcatFields = (index, selectedOption, name) => {
        console.log('waseem',index,selectedOption,name)
       // alert('ok')
        const temp = [...this.state.concatAdditionalFields];
        if (name.name === 'value_type') {
            temp[index] = { ...OC.CONCAT_OBJ }
            temp[index][name.name] = selectedOption.value;
        }
       // console.log(temp)
        this.setState({

            concatAdditionalFields: [...temp]
        })
    }

    onCheckFlag = (toggle, rowIndex, name) => {
        const atts = cloneDeep(this.state.rule_filters);
        atts[rowIndex][name] = !toggle;
        this.setState({ rule_filters: atts }, () => {
        });
    }
    onInputHandler = (e, rowIndex) => {
        const atts = cloneDeep(this.state.rule_filters);
        if (e.target.type === Rules.TEXT || e.target.type === 'select-one') {
            const { name, value } = e.target;
            atts[rowIndex][name] = value;
        }
        else if (e.target.type === 'checkbox') {
            const { name, checked } = e.target;
            atts[rowIndex][name] = checked;
        }
        this.setState({ rule_filters: atts });
    }

    targetInputHandler = (e) => {
        this.setState({
            target_attribute: {
                ...this.state.target_attribute,
                [e.target.name]: e.target.value
            }
        });
    }
    baseTargetInputHandler = (e) => {
        this.setState({
            base_target_attribute: {
                ...this.state.base_target_attribute,
                [e.target.name]: e.target.value
            }
        });
    }
    handleCheckStatus = (e) => {
        const { name, checked } = e.target;
        this.setState({
            brand_order_attributes: {
                ...this.state.brand_order_attributes,
                [name]: checked,
            }
        })
    }
    handleDateChange = (index, name, date) => {
        const rule_filters = this.state.rule_filters;
        const updated_filter = rule_filters[index];
        updated_filter[name] = date;
        updated_filter['param_static_value'] = [];
        updated_filter['param_field'] = '';
        updated_filter['param_field_id'] = '';
        updated_filter['dateRange'] = '';
        this.setState({
            rule_filters: rule_filters
        })
    }
    onDateRangeChange = (index, name, date) => {
        const rule_filters = this.state.rule_filters;
        const updated_filter = rule_filters[index];
        updated_filter[name] = date;
        updated_filter['date'] = null;
        updated_filter['param_static_value'] = [];
        updated_filter['param_field'] = '';
        updated_filter['param_field_id'] = '';
        this.setState({
            rule_filters: rule_filters
        })
    }
    handleTargetDateChange = (name, date) => {
        this.setState({
            target_attribute: {
                ...this.state.target_attribute,
                [name]: date
            }
        })
    }

    handleAddFilter = (e) => {
        e.preventDefault();
        const atts = cloneDeep(this.state.rule_filters);
        atts.push(...OC.RULE_FILTER);
        this.setState({
            rule_filters: atts,
            disableAddFilter: true
        }, () => {
        })
    }
    handleOnFocusSettingsIcon = (e, index) => {
        if (this.state.rule_filters[index].has_error) {
            const atts = cloneDeep(this.state.rule_filters);
            atts[index]['has_error'] = false;
            this.setState({ rule_filters: atts })
        }
    }
    //Method that renders the filters table
    createTable = (filters) => {
        return filters.map((data, index) => {
            return <React.Fragment key={index + 2}>
                <tr key={index} >

                    {/* Not */}
                    <td className="">
                        <ToggleButton
                            inactiveLabel={''}
                            activeLabel={''}
                            colors={themeCSSConstants.THUMBICONSTYLE}
                            trackStyle={themeCSSConstants.TRACKSTYLE}
                            thumbStyle={themeCSSConstants.THUMBSTYLE}
                            thumbAnimateRange={[4, 30]}
                            value={data['apply_not'] ? data['apply_not'] : ''}
                            name="apply_not"
                            onToggle={(e) => this.onCheckFlag(e, index, 'apply_not')}
                        />
                    </td>

                    {/* Paren start */}
                    <td>
                        <select className="form-control" onChange={(e) => this.onInputHandler(e, index)} style={this.state.paren_unequal || this.state.totalParen ? { border: '1px solid red' } : null} name='parenthesis_start'
                            value={data['parenthesis_start'] ? data['parenthesis_start'] : ""} >
                            {
                                OC.OPENING_PARENTHESIS.map((value, index) => (
                                    <option value={value.value} key={index} > {value.label} </option>
                                ))
                            }
                        </select>
                    </td>

                    {/* Attribute  */}
                    <td>
                        <Select
                            // value={HF.returnLabelWithValue(this.state.rule_filters[index]., OC.dataTypeList)}
                            name={'operand_attribute'}
                            onChange={(e, name) => this.handleDropdown(index, e, name)}
                            options={this.props.location.state.attributesProp}
                            getOptionLabel={(option) => option.title}
                            getOptionValue={(option) => option.id}
                            className='text-capitalize'
                            isSearchable={true}
                            isMulti={false}
                            placeholder={'Choose Attribute'}
                            isClearable={false}
                        />
                        {this.valitdatorList.message('Attribute', this.state.rule_filters[index].operand_attribute, 'required')}
                    </td>

                    {/* Operator */}
                    <td>
                        <Select
                            value={HF.returnLabelWithValue(this.state.rule_filters[index].operator, this.returnOperatorsList(this.state.rule_filters[index].operator_category))}
                            onChange={(e, name) => this.handleDropdown(index, e, name)}
                            options={this.state.rule_filters[index].operator_category ?
                                this.returnOperatorsList(this.state.rule_filters[index].operator_category) : []}
                            isSearchable={true}
                            name={'operator'}
                            className='text-capitalize'
                            isMulti={false}
                            placeholder={'Choose Operator'}
                            isClearable={false}
                        />
                        {this.valitdatorList.message('Operator', this.state.rule_filters[index].operator, 'required')}
                    </td>

                    {/* Param Type */}
                    <td>
                        <Select
                            value={HF.returnLabelWithValue(this.state.rule_filters[index].param_type, OC.PARAM_TYPES)}
                            onChange={(e, name) => this.handleDropdown(index, e, name)}
                            options={this.returnParamTypes(this.state.rule_filters[index].operator_category, index)}
                            isSearchable={true}
                            name={'param_type'}
                            className='text-capitalize'
                            isMulti={false}
                            placeholder={'Choose Option'}
                            isClearable={false}
                            isDisabled={this.state.rule_filters[index].operator === 'empty' ? true : false}
                        />
                        {
                            this.state.rule_filters[index].operator !== 'empty' ?
                                this.valitdatorList.message('Attribute', this.state.rule_filters[index].param_type, 'required')
                                : null
                        }
                    </td>

                    {/* Params */}
                    <td className="text-center">
                        <span className="customPopupContainer" onClick={() => this.popupHandler(index)}>
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip id="setParam">Click here to set parameter</Tooltip>
                            }>
                                <span className="paramIcon text-sm" style={this.state.rule_filters[index].has_error ? { color: 'red' } : null} ><FiSettings /></span>
                            </OverlayTrigger>
                            {
                                <div className={"customPopup text-left " + (this.state.rule_filters[index].popupHandler ? "" : "hidden")} onFocus={(event) => this.handleOnFocusSettingsIcon(event, index)}  >
                                    <span className="closePopup" onClick={(event) => this.closeHandler(event, index)}>
                                        <MdClose />
                                    </span>
                                    {
                                        this.returnParamField(this.state.rule_filters[index].param_type, this.state.rule_filters[index].operator_category, this.state.rule_filters[index].operator, index)
                                    }

                                    <div className="text-center">
                                        <button type="button" onClick={(event) => this.closeHandler(event, index)} style={{ width: 'auto' }} className="customBtn pt-xs pb-xs mt-xs pr-sm pl-sm btnBlue">Save</button>
                                    </div>
                                </div>
                            }
                        </span>
                    </td>

                    {/* Description */}
                    <td>
                        {
                            this.returnDescriptionField(this.state.rule_filters[index].param_type, this.state.rule_filters[index].operator_category, index)
                        }
                    </td>

                    {/* Parens */}
                    <td>
                        <select className="form-control" onChange={(e) => this.onInputHandler(e, index)} style={this.state.paren_unequal || this.state.totalParen ? { border: '1px solid red' } : null} name='parenthesis_end'
                            value={data['parenthesis_end'] ? data['parenthesis_end'] : ""} >
                            {
                                OC.CLOSING_PARENTHESIS.map((value, index) => (
                                    <option value={value.value} key={index} > {value.label} </option>
                                ))
                            }
                        </select>

                    </td>

                    {/* And/OR */}
                    <td>
                        <div style={{ position: 'relative' }}>
                            <Select
                                value={HF.returnLabelWithValue(this.state.rule_filters[index].logical_operator, OC.GATES)}
                                onChange={(e, name) => this.handleDropdown(index, e, name)}
                                options={this.returnGatesList(this.state.rule_filters[index].logical_operator)}
                                isSearchable={true}
                                className='text-capitalize'
                                name={'logical_operator'}
                                isMulti={false}
                                placeholder={'Select AND/OR'}
                                isClearable={false}
                            />
                            {
                                this.state.rule_filters.length > 0 &&
                                <div className="removeFilterContainer">
                                    <OverlayTrigger
                                        placement="left"
                                        overlay={
                                            <Tooltip id="removeFilter">Remove Filter</Tooltip>
                                        }>
                                        <span className="removeFilter" onClick={this.removeFilter}>
                                            <MdClose />
                                        </span>
                                    </OverlayTrigger>
                                </div>
                            }
                        </div>
                    </td>
                </tr>
                {
                    this.state.rule_filters[index].param_lookup_table_column ?
                        <tr key={index + 1} >
                            <td>&nbsp;</td>
                            {
                                this.state.rule_filters[index].param_lookup_table_column &&
                                <td colSpan='8'>
                                    <LookupFilter
                                        type='rule_filters'
                                        rowIndex={index}
                                        // valitdatorList={this.valitdatorList}
                                        lookup_attributes={this.returnLookupAttributesForLookupFilters(this.state.rule_filters[index]['param_lookup_table'], 'rule_filters', index)}
                                        attributesProp={this.props.location.state.attributesProp}
                                        handleLookupFilterSubmit={this.handleLookupFilterSubmit}
                                    />
                                </td>
                            }
                        </tr>
                        : null
                }
            </React.Fragment>

        })
    }

    getFormattedDate = (date) => {
        if (Array.isArray(date)) {
            return date.map(item => {
                if (item !== '' && item !== null) {
                    const formattedDate = new Date(item);
                    return (formattedDate.getMonth() + 1) + '/' + formattedDate.getDate() + '/' + formattedDate.getFullYear() + ' '
                } else {
                    return ''
                }
            })
        }
        else {
            if (date !== '' && date !== null) {
                const formattedDate = new Date(date);
                return (formattedDate.getMonth() + 1) + '/' + formattedDate.getDate() + '/' + formattedDate.getFullYear()
            } else {
                return ''
            }
        }
    }

    removeFilter = (e) => {
        e.preventDefault();
        const filters = this.state.rule_filters;
        const newArray = filters.slice(0, (filters.length - 1))
        if (filters.length > 1)
            this.setState({
                rule_filters: newArray
            })
        else
            this.setState({
                rule_filters: [],
                disableAddFilter: false
            })
    }

    warningMsg = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName="row" msgType='warning' description={"Add at least one filter that contains the same Lookup table as in Set Statement"} onClosePro={onClose} />
                )
            }
        })
    }

    lookupFilterWarningMsg = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName="row" msgType='warning' description={"Please fill in the lookup filters and save them."} onClosePro={onClose} />
                )
            }
        })
    }

    handleListSubmitForm(e) {
      // console.log(this.state.target_attribute)
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            let numOfStartParens = 0;
            let numOfEndParens = 0;
            const newArray = [];
            let labels;
            let lookupFilterCount = 0;
            let lookupParamTypeCount = 0;
            this.state.rule_filters.forEach(item => {
               // console.log(item)
                numOfStartParens += item.parenthesis_start.length
                numOfEndParens += item.parenthesis_end.length
                // const labels = item.param_static_value.map(element => {
                //     return element.label
                // })
                if (Array.isArray(item.param_static_value)) {
                    labels = item.param_static_value.map(element => {
                        return element.label
                    })
                }
                if (item.date !== null) {
                    if (Array.isArray(item.date)) {
                        newArray.push({
                            ...item,
                            // param_static_value: this.getFormattedDate(item.date),
                            param_static_value: item.date,
                        })
                    }
                    else {
                        newArray.push({
                            ...item,
                            // param_static_value: [this.getFormattedDate(item.date)],
                            param_static_value: [item.date],
                        })
                    }
                }
                else if (item.static_single_value) {
                    newArray.push({
                        ...item,
                        param_static_value: [item.static_single_value],
                    })
                }
                else {
                    newArray.push({
                        ...item,
                        param_static_value: labels
                    })
                }
                if (item.param_type === 'lookup') {
                    lookupParamTypeCount += 1;
                    if (item.lookup_filters.length > 0) {
                        lookupFilterCount += 1;
                    }
                }
            });

            // Validation for the Lookup FIlters start
            if (this.state.target_attribute_data_type !== 'url') {
                if (this.state.target_attribute[Rules.OPERAND_ONE_VALUE_TYPE] === 'lookup') {
                    if (this.state.operand_one_lookup_expression.length < 1) {
                        this.lookupFilterWarningMsg();
                        return
                    }
                }
                if (this.state.target_attribute[Rules.OPERAND_TWO_VALUE_TYPE] === 'lookup') {
                    if (this.state.operand_two_lookup_expression.length < 1) {
                        this.lookupFilterWarningMsg();
                        return
                    }
                }
            }
            else if (this.state.target_attribute_data_type === 'url') {
                if (this.state.target_attribute[Rules.OPERAND_ONE_VALUE_TYPE] === 'lookup') {
                    if (this.state.operand_one_lookup_expression.length < 1) {
                        this.lookupFilterWarningMsg();
                        return
                    }
                }
                if (this.state.base_target_attribute[Rules.OPERAND_TWO_VALUE_TYPE] === 'lookup') {
                    if (this.state.operand_two_lookup_expression.length < 1) {
                        this.lookupFilterWarningMsg();
                        return
                    }
                }
            }


            if (lookupParamTypeCount !== lookupFilterCount) {
                this.lookupFilterWarningMsg();
                return;
            }
            //Validtion for lookup filters end
            let obj = {};
            // for url case
            if (this.state.target_attribute_data_type === 'url') {
                obj = {
                    rule_filters: [...newArray],
                    // ...this.state.target_attribute, ...this.state.base_target_attribute,
                    target_attribute: this.props.location.state.targetAttribute.db_column,
                    target_attribute_title: this.props.location.state.targetAttribute.title,
                    target_attribute_id: this.props.location.state.targetAttribute.id,
                    target_attribute_data_type: this.state.target_attribute_data_type
                }
            }
            else {
              //  alert('ok')
               // console.log(...this.state)
                obj = {
                    rule_filters: [...newArray],
                    // ...this.state.target_attribute,
                    target_attribute: this.props.location.state.targetAttribute.db_column,
                    target_attribute_title: this.props.location.state.targetAttribute.title,
                    target_attribute_id: this.props.location.state.targetAttribute.id,
                    target_attribute_data_type: this.state.target_attribute_data_type
                }
            }
            // for url end

            if (numOfStartParens !== numOfEndParens) {
                this.setState({
                    totalParen: true
                })
            }
            if (obj.value_static instanceof Date) {
                obj.value_static = obj.value_static;
                obj.value_static = this.getFormattedDate(obj.value_static);
            }

            obj.actions = this.createTargetExpression()
           // alert('here')
          //  console.log(obj)
            obj.rule_filters = this.createRuleFiltersExpressions(obj.rule_filters);
       //     console.log('%c The Final Object is', 'color:blue', obj);
            // console.log("In case rule isn't being saved, remove the 'Require Lookup table condition' starting from line 622 to 661")
            // Start Logic for requiring A lookup table filter
            const { target_attribute } = this.state;
            if ((target_attribute.value_lookup_table && target_attribute.value_lookup_table_column) || ((target_attribute.search_lookup_table && target_attribute.search_lookup_table_column))) {
                if (this.state.rule_filters.length > 0) {
                    let lookupTableCount = 0;
                    let lookupColumnCount = 0;
                    this.state.rule_filters.forEach(data => {
                        if ((data.param_lookup_table === target_attribute.value_lookup_table && data.param_lookup_table) || (data.param_lookup_table === target_attribute.search_lookup_table && data.param_lookup_table)) {
                            lookupTableCount++;
                            lookupColumnCount++;
                        }
                    })

                    if (lookupTableCount > 0 && lookupColumnCount > 0) {
                        if (numOfStartParens === numOfEndParens && !this.state.paren_unequal) {
                            this.props.storeTransformationRulesCall(obj, this.props.location.state.definition_id).then(res => {
                                if (res.status === 'success') {
                                    this.props.history.goBack();
                                    // this.props.location.state.handleSubmit(res.result.transformation_rules, this.state.formType);
                                }
                            })
                        }
                    }
                    else {
                        this.warningMsg();
                    }
                }
                else {
                    this.warningMsg();
                }
            }
            else {
                if (numOfStartParens === numOfEndParens && !this.state.paren_unequal) {
                    this.props.storeTransformationRulesCall(obj, this.props.location.state.definition_id).then(res => {
                        if (res.status === 'success') {
                            this.props.history.goBack();
                            // this.props.location.state.handleSubmit(res.result.transformation_rules, this.state.formType);
                        }
                    })
                }
            }
            return
            // End of logic
            // In case of not working remove the upper lookup logic
            // if (numOfStartParens === numOfEndParens && !this.state.paren_unequal) {
            //     this.props.location.state.storeTransformationRulesCall(obj, this.props.location.state.definition_id)
            // }

        }
        else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
            const newArray = [];
            let labels;
            this.state.rule_filters.forEach(item => {
                if (Array.isArray(item.param_static_value)) {
                    labels = item.param_static_value.map(element => {
                        return element.label
                    })
                }
                if (item.date !== null) {
                    if (Array.isArray(item.date)) {
                        item.param_static_value = item.date;
                    }
                    else {
                        item.param_static_value = [item.date];
                    }
                }
                else if (item.static_single_value) {
                    item.param_static_value = [item.static_single_value];
                }
                else {
                    item.param_static_value = labels
                }
                // icon red logic
                if (item.param_type === 'static') {
                    if (Array.isArray(item.param_static_value)) {
                        if (item.param_static_value.length === 0) {
                            item.has_error = true;
                        }
                        else if (item.param_static_value.length > 0) {
                            item.has_error = false
                        }
                    }
                    else {
                        if (!item.param_static_value) {
                            item.has_error = true;
                        }
                        else if (item.param_static_value) {
                            item.has_error = false
                        }
                    }
                }
                else if (item.param_type === 'field') {
                    if (!item.param_field) {
                        item.has_error = true;
                    }
                    else if (item.param_field) {
                        item.has_error = false
                    }
                }
                else if (item.param_type === 'lookup') {
                    if (!item.param_lookup_table) {
                        item.has_error = true;
                    }
                    else if (item.param_lookup_table) {
                        item.has_error = false
                    }
                    if (!item.param_lookup_table_column) {
                        item.has_error = true;
                    }
                    else if (item.param_lookup_table_column) {
                        item.has_error = false;
                    }
                }
                else if (item.operator === 'empty') {
                    item.has_error = false
                }
                newArray.push(item);
            });

            this.setState({
                rule_filters: newArray
            })
        }


    }

    validateBrackets = (brackets) => {

    }
    returnOperatorsList(data_type) {
        switch (data_type) {
            case Rules.INTEGER:
            case Rules.FLOAT:
                return OC.INT_OPERATORS;
            case Rules.STRING:
            case Rules.TEXT:
                return OC.STRING_OPERATORS;
            case Rules.DATETIME:
                return OC.DATE_OPERATORS;
            case Rules.URL:
                return OC.URL_OPERATORS;
            default:
                return [];
        }
    }
    returnParamTypes(type, index) {
        if (type !== 'datetime' && this.state.rule_filters[index].operator === 'any of') {
            return OC.DISABLED_DATE_PARAM_TYPES;
        }
        switch (type) {
            case Rules.DATETIME:
                return OC.DISABLED_DATE_PARAM_TYPES;
            case Rules.INTEGER:
            case Rules.FLOAT:
                return OC.DISABLED_INT_PARAM_TYPES;
            default:
                return OC.PARAM_TYPES;
        }
    }
    returnGatesList(gate) {
        switch (gate) {
            case 'none':
                return OC.GATES;
            case 'and':
                return OC.GATES;
            case 'or':
                return OC.GATES;
            default:
                return OC.GATES;
        }
    }
    returnActionsList(data_type) {
        switch (data_type) {
            case Rules.INTEGER:
            case Rules.FLOAT:
                return OC.TARGET_ATTRIBUTE_ACTIONS_INT;
            case Rules.STRING:
            case Rules.TEXT:
                return OC.TARGET_ATTRIBUTE_ACTIONS_STRING;
            case Rules.DATETIME:
                return OC.TARGET_ATTRIBUTE_ACTIONS_DATE;
            case Rules.URL:
                return OC.TARGET_ATTRIBUTE_ACTIONS_URL
            default:
                return [];
        }
    }
    handleAddLookupFilterClick = (e) => {
        const { name } = e.target;
        this.setState({
            [name]: true
        })
    }
    addLookupFilterTarget = (type, name, attribute_name = '') => {
        if (this.state.target_attribute_data_type === 'url') {
            return <LookupFilter
                borderClass={true}
                type={type}
                // valitdatorList={this.valitdatorList}
                lookup_attributes={this.returnLookupAttributesForLookupFilters(this.state[attribute_name][name], 'target')}
                attributesProp={this.props.location.state.attributesProp}
                handleLookupFilterSubmit={this.handleLookupFilterSubmit}
            />
        } else {
            return <LookupFilter
                borderClass={true}
                type={type}
                // valitdatorList={this.valitdatorList}
                lookup_attributes={this.returnLookupAttributesForLookupFilters(this.state.target_attribute[name], 'target')}
                attributesProp={this.props.location.state.attributesProp}
                handleLookupFilterSubmit={this.handleLookupFilterSubmit}
            />
        }
    }
    returnLookupAttributesForLookupFilters = (table_name, type, rowIndex = null) => {
        if (type === 'target') {
            const { attributesLookup } = this.state;
            const titles = attributesLookup.map(data => {
                return data.table_name;
            });

            const index = titles.indexOf(table_name);
            if (index >= 0) {
                const stringArray = attributesLookup[index].attributes;
                return stringArray;
            }
        }
        else if (type === 'rule_filters') {
            const { attributesLookup } = this.state;
            const titles = attributesLookup.map(data => {
                return data.table_name;
            });
            const index = titles.indexOf(table_name);
            if (index >= 0) {
                const stringArray = attributesLookup[index].attributes;
                return stringArray;
            }
        }

    }
    addLookupFilterRuleFilters = (type, rowIndex) => {

    }

    returnParamField(param_type, operator_category, operator, index) {
        if (param_type === 'static' && operator_category === Rules.DATETIME) {
            if (operator === 'between') {
                return <span>
                    <DateRangePicker
                        className="form-control"
                        onChange={(e) => this.handleDateChange(index, "date", e)}
                        value={this.state.rule_filters[index].date}
                        placeholderText={`11/06/2019 - 11/22/2019`}
                    />
                    {
                        this.state.rule_filters[index].operator !== 'empty' ?
                            this.valitdatorList.message('Param', this.state.rule_filters[index].date, 'required')
                            : null
                    }
                </span>
            }
            else {
                return <span>
                    <DatePicker
                        className="form-control"
                        value={this.state.rule_filters[index].date}
                        onChange={(e) => this.handleDateChange(index, "date", e)}
                        placeholderText={`11/06/2019`}
                    />
                    {
                        this.state.rule_filters[index].operator !== 'empty' ?
                            this.valitdatorList.message('Param', this.state.rule_filters[index].date, 'required')
                            : null
                    }
                </span>
            }
        }
        else if (param_type === 'static' && operator_category !== Rules.DATETIME) {
            switch (operator) {
                // integer cases start
                case 'equals to':
                case 'greater than':
                case 'greater than or equal':
                case 'less than':
                case 'less than or equal':
                // integer cases end
                //string cases start
                case 'empty':
                case 'begins with':
                case 'ends with':
                case 'contains':
                    //string cases end
                    return <span>
                        <label htmlFor="param_static_value">Add Value:</label>
                        <input type="text" name="static_single_value" value={this.state.rule_filters[index].static_single_value} className="form-control"
                            disabled={this.state.rule_filters[index].operator === 'empty' ? true : false} onChange={(e) => this.onInputHandler(e, index)} />
                        {
                            this.valitdatorList.message('Param', this.state.rule_filters[index].static_single_value, 'required')
                        }
                    </span>
                case 'between':
                case 'any of':
                    return <span>
                        <label htmlFor="param_static_value">Add Values:</label>
                        <CreatableSelect
                            components={components}
                            inputValue={this.state.rule_filters[index].creatable_value}
                            isClearable
                            isMulti
                            key={index}
                            menuIsOpen={false}
                            onChange={(event, action) => this.handleCreatableChange(index, "param_static_value", event, action)}
                            onInputChange={(event, action) => this.handleCreatableInputChange(index, "param_static_value", event)}
                            onKeyDown={e => this.handleCreatableKeyDown(e, index, "param_static_value")}
                            name="param_static_value"
                            placeholder="Type something and press tab"
                            value={this.state.rule_filters[index].param_static_value}
                            isDisabled={this.state.rule_filters[index].operator === 'empty' ? true : false}
                        />
                        {this.state.duplicate_error[index] && <span style={{ color: 'red' }}>Value already exists in the list.</span>}
                        {
                            this.state.rule_filters[index].operator !== 'empty' ?
                                this.valitdatorList.message('Param', this.state.rule_filters[index].param_static_value, 'required')
                                : null
                        }
                    </span>
                default:
                    return <span></span>
            }
        }

        else if (param_type === 'lookup') {
            return <div>
                <div className="formLabel">Lookup Table</div>
                <span>
                    <Select
                        // value={HF.returnLabelWithValue(this.state.rule_filters[index].logical_operator, OC.GATES)}
                        onChange={(e, name) => this.handleDropdown(index, e, name)}
                        options={this.state.attributesLookup}
                        isSearchable={true}
                        className='text-capitalize'
                        key={index}
                        name={'param_lookup_table'}
                        getOptionLabel={(option) => option.table_name}
                        getOptionValue={(option) => option.id}
                        isMulti={false}
                        placeholder={'Lookup Table'}
                        isClearable={false}
                        isDisabled={this.state.rule_filters[index].operator === 'empty' ? true : false}
                    />
                    {this.valitdatorList.message('Lookup Table', this.state.rule_filters[index].param_lookup_table, 'required')}
                </span>

                <div className="formLabel">Lookup Attribute</div>
                <span>
                    <Select
                        value={HF.returnTitleWithDb_column(this.state.rule_filters[index].param_lookup_table_column, this.returnRuleFiltersLookupAttributes(index, this.state.rule_filters[index]['param_lookup_table']))}
                        onChange={(e, name) => this.handleDropdown(index, e, name)}
                        options={this.returnRuleFiltersLookupAttributes(index, this.state.rule_filters[index]['param_lookup_table'])}
                        isSearchable={true}
                        className='text-capitalize'
                        key={index + 1}
                        name={'param_lookup_table_column'}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        isMulti={false}
                        placeholder={'Lookup Attribute'}
                        isClearable={false}
                        isDisabled={this.state.rule_filters[index].operator === 'empty' ? true : false}
                    />
                    {this.valitdatorList.message('Lookup Attribute', this.state.rule_filters[index].param_lookup_table_column, 'required')}
                </span>
            </div>
        }

        else {
            return <div className="form-group">
                <div className="formLabel">Value Attribute</div>
                <Select
                    value={HF.returnTitleWithId(this.state.rule_filters[index].param_field_id, this.props.location.state.attributesProp)}
                    name={'param_field'}
                    onChange={(e, name) => this.handleDropdown(index, e, name)}
                    options={this.props.location.state.attributesProp}
                    getOptionLabel={(option) => option.title}
                    getOptionValue={(option) => option.id}
                    className='text-capitalize'
                    isSearchable={true}
                    isMulti={false}
                    placeholder={'Choose Attribute'}
                    isClearable={false}
                    isDisabled={this.state.rule_filters[index].operator === 'empty' ? true : false}
                />
                {
                    this.state.rule_filters[index].operator !== 'empty' ?
                        this.valitdatorList.message('Param', this.state.rule_filters[index].param_field, 'required')
                        : null
                }
            </div>
        }
    }

    returnDescriptionField = (param_type, operator_category, index) => {
        const { rule_filters } = this.state;
        if (param_type === 'static' && operator_category !== Rules.DATETIME && operator_category !== '') {
            if (rule_filters[index].param_static_value.length > 0) {
                let val = `${rule_filters[index].operand_attribute} ${rule_filters[index].operator} ${rule_filters[index].param_static_value.map(item => item.label)}`
                return (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">{val} </Tooltip>}>
                        <span>
                            <input type="text" name="description" className="form-control" value={val} disabled={true} />
                        </span>
                    </OverlayTrigger>
                )
            }
            else {
                let val1 = `${rule_filters[index].operand_attribute} ${rule_filters[index].operator}`
                return (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">{val1} </Tooltip>}>
                        <span>
                            <input type="text" name="description" className="form-control" placeholder="Expression"
                                value={val1} disabled={true} />
                        </span>
                    </OverlayTrigger>
                )
            }
        }

        else if (param_type === 'field' && operator_category !== Rules.DATETIME && operator_category !== '') {
            let val2 = `${rule_filters[index].operand_attribute} ${rule_filters[index].operator} ${rule_filters[index].param_field}`
            return (
                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">{val2}</Tooltip>}>
                    <span>
                        <input type="text" name="description" className="form-control" value={val2} disabled={true} />
                    </span>
                </OverlayTrigger>
            )
        }
        //Need a case FOr LOOKUP tables
        else if (param_type === 'lookup' && operator_category !== Rules.DATETIME) {
            let tableVal = `${rule_filters[index].operand_attribute} ${rule_filters[index].operator} ${rule_filters[index].param_lookup_table} ${rule_filters[index].param_lookup_table_column}`
            return (
                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">{tableVal}</Tooltip>}>
                    <span>
                        <input type="text" name="description" className="form-control" value={tableVal} disabled={true} />
                    </span>
                </OverlayTrigger>
            )
        }
        else if (param_type === 'static' && operator_category === Rules.DATETIME) {
            if (rule_filters[index].date !== null) {
                if (Array.isArray(rule_filters[index].date)) {
                    let val3 = `${rule_filters[index].operand_attribute} ${rule_filters[index].operator} ${this.getFormattedDate(rule_filters[index].date)}`

                    return (
                        <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">{val3}</Tooltip>}>
                            <span>
                                <input type="text" name="description" className="form-control" value={val3} disabled={true} />
                            </span>
                        </OverlayTrigger>
                    )
                }
                else if (!Array.isArray(rule_filters[index].date)) {
                    let val4 = `${rule_filters[index].operand_attribute} ${rule_filters[index].operator} ${this.getFormattedDate(rule_filters[index].date)}`;

                    return (
                        <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">{val4}</Tooltip>}>
                            <span>
                                <input type="text" name="description" className="form-control" value={val4} disabled={true} />
                            </span>
                        </OverlayTrigger>
                    )
                }
            }
            else {
                return <input type="text" name="description" className="form-control" placeholder="Expression" disabled={true} />
            }
        }
        else {
            return (
                <span>
                    <input type="text" name="description" className="form-control" placeholder="Expression" disabled={true} />
                </span>
            )
        }
    }

    handleCreatableChange = (index, name, value, actionMeta) => {
        const rule_filters = this.state.rule_filters;
        const updated_filter = rule_filters[index];
        updated_filter[name] = value;
        this.setState({
            rule_filters: rule_filters
        })

    };
    handleCreatableInputChange = (index, name, inputValue) => {
        const atts = cloneDeep(this.state.rule_filters);
        atts[index]['creatable_value'] = inputValue;
        this.setState({ rule_filters: atts }, () => { })

    };

    handleCreatableKeyDown = (event, index, name) => {
        // const { inputValue, value } = this.state;
        if (!this.state.rule_filters[index].creatable_value) return;
        switch (event.key) {
            case 'Tab':
            case 'Enter':
                const atts = cloneDeep(this.state.rule_filters);
                atts[index][name] = [...this.state.rule_filters[index].param_static_value, createOption(this.state.rule_filters[index].creatable_value)];
                const params = this.state.rule_filters[index].param_static_value.map((item, key) => {
                    return item.label
                })
                if (params.includes(this.state.rule_filters[index].creatable_value)) {
                    this.setState({
                        duplicate_error: {
                            ...this.state.duplicate_error,
                            [index]: true
                        },
                    })
                    event.preventDefault();
                    return
                }
                this.setState({
                    ...this.state,
                    duplicate_error: {
                        ...this.state.duplicate_error,
                        [index]: false
                    },
                    rule_filters: atts
                },
                    () => {
                        const atts = cloneDeep(this.state.rule_filters);
                        atts[index]['creatable_value'] = '';
                        this.setState({ rule_filters: atts })
                    })
                event.preventDefault();
                break;
            default:
                return '';
        }
    };

    setTargetRadio = e => {
        const { target_attribute } = this.state;
        const { name, value } = e.target;
        this.setState({
            target_attribute: {
                ...this.state.target_attribute,
                [name]: value,
            }
        }, () => {
            if (target_attribute[Rules.OPERAND_ONE_VALUE_TYPE] === 'static') {
                if (name === 'set_value_action') {
                    if (value === 'empty' || value === 'null') {
                        this.setState({
                            target_attribute: {
                                ...this.state.target_attribute,
                                [Rules.OPERAND_ONE_VALUE_STATIC]: '',
                                [Rules.OPERAND_ONE_VALUE_STATIC]: ''
                            }
                        })
                    }
                }
            }
            if (target_attribute[Rules.OPERAND_TWO_VALUE_TYPE] === 'static') {
                if (value === 'empty' || value === 'null') {
                    if (name === 'set_replace_string') {
                        this.setState({
                            target_attribute: {
                                ...this.state.target_attribute,
                                [Rules.OPERAND_TWO_VALUE_STATIC]: ''
                            }
                        })
                    }
                }
            }
        })

    }
    returnReplaceTargetFields = (datatype, value_type, name) => {
        const { target_attribute } = this.state;
        if (datatype === Rules.STRING || datatype === Rules.TEXT) {
            if (name === 'search_string_type') {
                if (value_type === 'static') {
                    return <div className="form-group">
                        <div className="formLabel">Search Value</div>
                        <div>
                            <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} value={target_attribute[Rules.OPERAND_ONE_VALUE_STATIC] ? target_attribute[Rules.OPERAND_ONE_VALUE_STATIC] : ''} />
                            {this.valitdatorList.message('Search Value', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required')}
                        </div>
                    </div>
                }
                else if (value_type === 'field') {
                    return <div className="form-group">
                        <div className="formLabel">Search Value Attribute</div>
                        <Select
                            // value={HF.returnLabelWithValue(brand_order_attributes.data_type, OC.dataTypeList)}
                            name={Rules.OPERAND_ONE_VALUE_FIELD}
                            onChange={this.handleTargetDropdown}
                            options={this.props.location.state.attributesProp}
                            getOptionLabel={(option) => option.title}
                            getOptionValue={(option) => option.id}
                            className='text-capitalize'
                            isSearchable={true}
                            isMulti={false}
                            placeholder={'Choose Attribute'}
                            isClearable={false}
                        />
                        {this.valitdatorList.message('Search Attribute', target_attribute[Rules.OPERAND_ONE_VALUE_FIELD], 'required')}
                    </div>
                }
                else if (value_type === 'lookup') {
                    return <React.Fragment>
                        {
                            this.returnLookupTables(Rules.OPERAND_ONE_LOOKUP_TABLE, Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN)
                        }
                        {
                            this.state.target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN] &&
                            this.addLookupFilterTarget('operand_one_lookup', Rules.OPERAND_ONE_LOOKUP_TABLE)
                        }
                    </React.Fragment>
                }
                else {
                    return <div>
                        <div style={{ height: '88px' }}>
                            &nbsp;
                        </div>
                    </div>
                }
            }
            if (name === 'replace_string_type') {
                if (value_type === 'static') {
                    return <div>
                        <div className="formLabel" onChange={this.setTargetRadio}>
                            <label
                                className="container-radio">
                                <input type="radio" value="empty" name="set_replace_string" defaultChecked />
                                <span className="checkmark"></span>
                                Set Empty
                            </label>
                            <label
                                className="container-radio">
                                <input type="radio" value='null' name="set_replace_string" />
                                <span className="checkmark"></span>
                                Set Null
                            </label>
                            <label
                                className="container-radio">
                                <input type="radio" value='input' name="set_replace_string" />
                                <span className="checkmark"></span>
                                Custom Value
                            </label>
                        </div>
                        <div>
                            <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_TWO_VALUE_STATIC} disabled={target_attribute.set_replace_string === 'input' ? false : true} value={target_attribute[Rules.OPERAND_TWO_VALUE_STATIC] ? target_attribute[Rules.OPERAND_TWO_VALUE_STATIC] : ''} />
                            {
                                target_attribute.set_replace_string === 'input' ?
                                    this.valitdatorList.message('Replace Static Value', target_attribute[Rules.OPERAND_TWO_VALUE_STATIC], 'required') : null
                            }
                        </div>
                    </div>
                }
                else if (value_type === 'field') {
                    return <div className="form-group">
                        <div className="formLabel">Replace Value Attribute</div>
                        <Select
                            // value={HF.returnLabelWithValue(brand_order_attributes.data_type, OC.dataTypeList)}
                            name={Rules.OPERAND_TWO_VALUE_FIELD}
                            onChange={this.handleTargetDropdown}
                            options={this.props.location.state.attributesProp}
                            getOptionLabel={(option) => option.title}
                            getOptionValue={(option) => option.id}
                            className='text-capitalize'
                            isSearchable={true}
                            isMulti={false}
                            placeholder={'Choose Attribute'}
                            isClearable={false}
                        />
                        {this.valitdatorList.message('Replace attribute', target_attribute[Rules.OPERAND_TWO_VALUE_FIELD], 'required')}
                    </div>
                }
                else if (value_type === 'lookup') {
                    return <React.Fragment>
                        {
                            this.returnLookupTables(Rules.OPERAND_TWO_LOOKUP_TABLE, Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN)
                        }
                        {
                            this.state.target_attribute[Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN] &&
                            this.addLookupFilterTarget('operand_two_lookup', Rules.OPERAND_TWO_LOOKUP_TABLE)
                        }
                    </React.Fragment>
                }
            }
        }
        else if (datatype === Rules.INTEGER || datatype === Rules.FLOAT) {
            if (name === Rules.OPERAND_ONE_VALUE_TYPE) {
                if (value_type === 'static') {
                    return <div className="form-group">
                        <div className="formLabel">Operand 1 Value</div>
                        <div>
                            <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} value={target_attribute[Rules.OPERAND_ONE_VALUE_STATIC] ? target_attribute[Rules.OPERAND_ONE_VALUE_STATIC] : ''} />
                            {this.valitdatorList.message('Operand 1 Value', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required|numeric')}
                        </div>
                    </div>
                }
                else if (value_type === 'field') {
                    return <div className="form-group">
                        <div className="formLabel">Operand 1 Value Attribute</div>
                        <Select
                            // value={HF.returnLabelWithValue(brand_order_attributes.data_type, OC.dataTypeList)}
                            name={Rules.OPERAND_ONE_VALUE_FIELD}
                            onChange={this.handleTargetDropdown}
                            options={this.props.location.state.attributesProp}
                            getOptionLabel={(option) => option.title}
                            getOptionValue={(option) => option.id}
                            className='text-capitalize'
                            isSearchable={true}
                            isMulti={false}
                            placeholder={'Choose Attribute'}
                            isClearable={false}
                        />
                        {this.valitdatorList.message('Operand 1 Value Attribute', target_attribute[Rules.OPERAND_ONE_VALUE_FIELD], 'required')}
                    </div>
                }
                else if (value_type === 'lookup') {
                    return <React.Fragment>
                        {
                            this.returnLookupTables(Rules.OPERAND_ONE_LOOKUP_TABLE, Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN)
                        }
                        {
                            this.state.target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN] &&
                            this.addLookupFilterTarget(`operand_one_lookup`, Rules.OPERAND_ONE_LOOKUP_TABLE)
                        }
                    </React.Fragment>
                }
                else {
                    return <div>
                        <div style={{ height: '88px' }}>
                            &nbsp;
                        </div>
                    </div>
                }
            }
            if (name === Rules.OPERAND_TWO_VALUE_TYPE) {
                if (value_type === 'static') {
                    return <div className="form-group">
                        <div className="formLabel">Operand 2 Value</div>
                        <div>
                            <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_TWO_VALUE_STATIC} value={target_attribute[Rules.OPERAND_TWO_VALUE_STATIC] ? target_attribute[Rules.OPERAND_TWO_VALUE_STATIC] : ''} />
                            {this.valitdatorList.message('Operand 2 Value', target_attribute[Rules.OPERAND_TWO_VALUE_STATIC], 'required|numeric')}
                        </div>
                    </div>
                }
                else if (value_type === 'field') {
                    return <div className="form-group">
                        <div className="formLabel">Operand 2 Value Attribute</div>
                        <Select
                            // value={HF.returnLabelWithValue(brand_order_attributes.data_type, OC.dataTypeList)}
                            name={Rules.OPERAND_TWO_VALUE_FIELD}
                            onChange={this.handleTargetDropdown}
                            options={this.props.location.state.attributesProp}
                            getOptionLabel={(option) => option.title}
                            getOptionValue={(option) => option.id}
                            className='text-capitalize'
                            isSearchable={true}
                            isMulti={false}
                            placeholder={'Choose Attribute'}
                            isClearable={false}
                        />
                        {this.valitdatorList.message('Operand 2 Value attribute', target_attribute[Rules.OPERAND_TWO_VALUE_FIELD], 'required')}
                    </div>
                }
                else if (value_type === 'lookup') {
                    return <React.Fragment>
                        {
                            this.returnLookupTables(Rules.OPERAND_TWO_LOOKUP_TABLE, Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN)
                        }
                        {
                            this.state.target_attribute[Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN] &&
                            this.addLookupFilterTarget(`operand_two_lookup`, Rules.OPERAND_TWO_LOOKUP_TABLE)
                        }
                    </React.Fragment>

                }
            }
        }
    }

    returnConcatFields = (datatype, value_type, name) => {
        const { target_attribute } = this.state;
        if (datatype === Rules.STRING || datatype === Rules.TEXT) {
            if (name === 'first_operand') {
                if (value_type === 'static' || value_type === 'concatby') {
                    return <div className="form-group">

                        <div className="formLabel"> {value_type === 'static' ? 'Search Value':'Enter Accurate Html Entity(s)'}</div>

                        <div>
                            <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} value={target_attribute[Rules.OPERAND_ONE_VALUE_STATIC] ? target_attribute[Rules.OPERAND_ONE_VALUE_STATIC] : ''} />
                            {this.valitdatorList.message('Search Value', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required')}
                        </div>
                    </div>
                }
                else if (value_type === 'field') {
                    return <div className="form-group">
                        <div className="formLabel">Value Attribute</div>
                        <Select
                            // value={HF.returnLabelWithValue(brand_order_attributes.data_type, OC.dataTypeList)}
                            name={Rules.OPERAND_ONE_VALUE_FIELD}
                            onChange={this.handleTargetDropdown}
                            options={this.props.location.state.attributesProp}
                            getOptionLabel={(option) => option.title}
                            getOptionValue={(option) => option.id}
                            className='text-capitalize'
                            isSearchable={true}
                            isMulti={false}
                            placeholder={'Choose Attribute'}
                            isClearable={false}
                        />
                        {this.valitdatorList.message('Search Attribute', target_attribute[Rules.OPERAND_ONE_VALUE_FIELD], 'required')}
                    </div>
                }
                else if (value_type === 'lookup') {
                    return <React.Fragment>
                        {
                            this.returnLookupTables(Rules.OPERAND_ONE_LOOKUP_TABLE, Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN)
                        }
                        {
                            this.state.target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN] &&
                            this.addLookupFilterTarget('operand_one_lookup', Rules.OPERAND_ONE_LOOKUP_TABLE)
                        }
                    </React.Fragment>
                }
                else {
                    return <div>
                        <div style={{ height: '88px' }}>
                            &nbsp;
                        </div>
                    </div>
                }
            }
        }
    }

    returnLookupTables = (table, attributes, index = 0) => {
        return <div className="flexElem twoColsFlex form-group">
            <div>
                <div className="formLabel">Lookup Table</div>
                <Select
                    // value={this.state.target_attribute[table] ? createLookupTableOption(this.state.target_attribute[table]) : ''}
                    onChange={this.handleTargetDropdown}
                    options={this.state.attributesLookup}
                    isSearchable={true}
                    className='text-capitalize'
                    key={index}
                    name={table}
                    getOptionLabel={(option) => option.table_name}
                    getOptionValue={(option) => option.id}
                    isMulti={false}
                    placeholder={'Lookup Table'}
                    isClearable={false}
                />
                {this.valitdatorList.message(`${table}`, this.state.target_attribute[table], 'required')}
            </div>

            <div>
                <div className="formLabel">Lookup Attribute</div>
                <Select
                    value={HF.returnTitleWithDb_column(this.state.target_attribute[attributes], this.returnTargetLookupAttributes(this.state.target_attribute[table]))}
                    onChange={this.handleTargetDropdown}
                    options={this.returnTargetLookupAttributes(this.state.target_attribute[table])}
                    isSearchable={true}
                    className='text-capitalize'
                    key={index + 1}
                    name={attributes}
                    getOptionLabel={(option) => option.title}
                    getOptionValue={(option) => option.db_column}
                    isMulti={false}
                    placeholder={'Lookup Attribute'}
                    isClearable={false}
                />
                {this.valitdatorList.message(`${attributes}`, this.state.target_attribute[attributes], 'required')}
            </div>
        </div>
    }
    returnBaseLookupTables = (table, attributes, attribute_name) => {
        return <div className="flexElem twoColsFlex form-group">
            <div>
                <div className="formLabel">Lookup Table</div>
                <Select
                    // value={HF.returnLabelWithValue(this.state.rule_filters[index].logical_operator, OC.GATES)}
                    onChange={this.handleBaseTargetDropdown}
                    options={this.state.attributesLookup}
                    isSearchable={true}
                    className='text-capitalize'
                    key={0}
                    name={table}
                    getOptionLabel={(option) => option.table_name}
                    getOptionValue={(option) => option.id}
                    isMulti={false}
                    placeholder={'Lookup Table'}
                    isClearable={false}
                />
                {this.valitdatorList.message(`${table}`, this.state[attribute_name][table], 'required')}
            </div>

            <div>
                <div className="formLabel">Lookup Attribute</div>
                <Select
                    value={HF.returnTitleWithDb_column(this.state[attribute_name][attributes], this.returnTargetLookupAttributes(this.state[attribute_name][table]))}
                    onChange={this.handleBaseTargetDropdown}
                    options={this.returnTargetLookupAttributes(this.state[attribute_name][table])}
                    isSearchable={true}
                    className='text-capitalize'
                    key={1}
                    name={attributes}
                    getOptionLabel={(option) => option.title}
                    getOptionValue={(option) => option.id}
                    isMulti={false}
                    placeholder={'Lookup Attribute'}
                    isClearable={false}
                />
                {this.valitdatorList.message(`${attributes}`, this.state[attribute_name][attributes], 'required')}

            </div>
        </div>
    }
    returnRuleFiltersLookupAttributes = (rowIndex, table_name) => {
        const { attributesLookup, rule_filters } = this.state;
        const titles = attributesLookup.map(data => {
            return data.table_name;
        });
        const index = titles.indexOf(table_name);
        if (index >= 0) {
            if (rule_filters[rowIndex].operator_category === Rules.STRING || rule_filters[rowIndex].operator_category === Rules.TEXT) {
                const stringArray = attributesLookup[index].attributes;
                return stringArray;
            }
            else if (rule_filters[rowIndex].operator_category === Rules.INTEGER || rule_filters[rowIndex].operator_category === Rules.FLOAT) {
                const integerArray = attributesLookup[index].attributes.filter((data, row) => {
                    if (data.data_type === Rules.INTEGER || data.data_type === Rules.FLOAT || data.data_type === Rules.STRING || data.data_type === Rules.TEXT) {
                        return data;
                    }
                })
                return integerArray;
            }
            else if (rule_filters[rowIndex].operator_category === Rules.INTEGER) {
                const dateArray = attributesLookup[index].attributes.filter((data, row) => {
                    if (data.data_type === Rules.DATETIME || data.data_type === Rules.STRING || data.data_type === Rules.TEXT) {
                        return data;
                    }
                })
                return dateArray;
            }
            else if (rule_filters[rowIndex].operator_category === Rules.URL) {
                const urlArray = attributesLookup[index].attributes.filter((data, row) => {
                    if (data.data_type === Rules.URL || data.data_type === Rules.STRING || data.data_type === Rules.TEXT) {
                        return data;
                    }
                })
                return urlArray;
            }
            else {
                return [];
            }
        }
        return [];
    }
    returnTargetLookupAttributes = (table_name) => {
        const { attributesLookup, target_attribute_data_type } = this.state;
        const titles = attributesLookup.map(data => {
            return data.table_name;
        });

        const index = titles.indexOf(table_name);
        if (index >= 0) {
            if (target_attribute_data_type === Rules.STRING || target_attribute_data_type === Rules.TEXT) {
                const stringArray = attributesLookup[index].attributes;
                return stringArray;
            }
            else if (target_attribute_data_type === Rules.INTEGER || target_attribute_data_type === Rules.FLOAT) {
                const integerArray = attributesLookup[index].attributes.filter((data, row) => {
                    if (data.data_type === Rules.INTEGER || data.data_type === Rules.FLOAT || data.data_type === Rules.STRING || data.data_type === Rules.TEXT) {
                        return data;
                    }
                })
                return integerArray;
            }
            else if (target_attribute_data_type === Rules.DATETIME) {
                const dateArray = attributesLookup[index].attributes.filter((data, row) => {
                    if (data.data_type === Rules.DATETIME || data.data_type === Rules.STRING || data.data_type === Rules.TEXT) {
                        return data;
                    }
                })
                return dateArray;
            }
            else if (target_attribute_data_type === Rules.URL) {
                const urlArray = attributesLookup[index].attributes.filter((data, row) => {
                    if (data.data_type === Rules.URL || data.data_type === Rules.STRING || data.data_type === Rules.TEXT) {
                        return data;
                    }
                })
                return urlArray;
            }
            else {
                return [];
            }
        }
        return [];
    }
    returnStaticRadios = () => {
        return <div className="formLabel">
            <label
                className="container-radio">
                <input type="radio" value="empty" name="set_value_action" onChange={this.setTargetRadio} />
                <span className="checkmark"></span>
                Set Empty
            </label>
            <label
                className="container-radio">
                <input type="radio" value='null' name="set_value_action" onChange={this.setTargetRadio} defaultChecked />
                <span className="checkmark"></span>
                Set Null
            </label>
            <label
                className="container-radio">
                <input type="radio" value='input' name="set_value_action" onChange={this.setTargetRadio} />
                <span className="checkmark"></span>
                Custom Value
            </label>
        </div>
    }
    handleLookupFilterSubmit = (data, type, rowIndex) => {
        if (type === 'operand_one_lookup') {
            this.setState({
                operand_one_lookup_expression: data
            }, () => {
              //  console.log('setting the object', this.state.operand_one_lookup_expression)
            })
        }
        else if (type === 'operand_two_lookup') {
            this.setState({
                operand_two_lookup_expression: data
            })
        }
        else if (type === 'rule_filters') {
            const filters = cloneDeep(this.state.rule_filters);
            filters[rowIndex].lookup_filters = data;
            this.setState({
                rule_filters: filters
            })
        }
    }
    returnTargetFields(datatype, action, value_type) {
        const { target_attribute } = this.state;
        if (datatype === Rules.STRING || datatype === Rules.TEXT) {
            if (action === 'set' && value_type === 'static') {
                return <div>
                    <div className="formLabel">
                        {
                            this.returnStaticRadios()
                        }
                    </div>
                    <div>
                        {
                            target_attribute.set_value_action === 'input' ?
                                <React.Fragment>
                                    <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} placeholder="Custom Value" />
                                    {
                                        this.valitdatorList.message('Value Static', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required')
                                    }
                                </React.Fragment>
                                :
                                <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} placeholder="Custom Value" disabled={true} />
                        }
                    </div>
                </div>
            }
            else if ((action === Rules.APPEND || action === Rules.PREPEND) && value_type === 'static') {
                return <div>
                    <div className="formLabel">Static Value String</div>
                    <div>
                        <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} />
                        {
                            this.valitdatorList.message('Value Static', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required')
                        }
                    </div>
                </div>
            }
            else if (value_type === 'field') {
                return <div className="form-group">
                    <div className="formLabel">Value Attribute</div>
                    <Select
                        value={HF.returnTitleWithId(target_attribute[Rules.OPERAND_ONE_VALUE_FIELD_ID], this.props.location.state.attributesProp)}
                        name={Rules.OPERAND_ONE_VALUE_FIELD}
                        onChange={this.handleTargetDropdown}
                        options={this.props.location.state.attributesProp}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        className='text-capitalize'
                        isSearchable={true}
                        isMulti={false}
                        placeholder={'Choose Attribute'}
                        isClearable={false}
                    />
                    {
                        this.valitdatorList.message('Value Field', target_attribute[Rules.OPERAND_ONE_VALUE_FIELD], 'required')
                    }
                </div>
            }
            else if (value_type === 'lookup') {
                return <React.Fragment>
                    {
                        this.returnLookupTables(Rules.OPERAND_ONE_LOOKUP_TABLE, Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN)
                    }
                    {
                        this.state.target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN] &&
                        this.addLookupFilterTarget('operand_one_lookup', Rules.OPERAND_ONE_LOOKUP_TABLE)
                    }
                </React.Fragment>
            }
            else {
                return <div>
                    <div>
                        <span>
                            {/* <input type="text" onChange={this.targetInputHandler} name="value_static" /> */}
                        </span>
                    </div>
                </div>
            }
        }
        if ((datatype === Rules.INTEGER || datatype === Rules.FLOAT) && action !== undefined) {
            if (action === 'set' && value_type === 'static') {
                return <div>
                    <div>
                        {
                            this.returnStaticRadios()
                        }

                    </div>
                    <div>
                        <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} disabled={target_attribute.set_value_action === 'input' ? false : true} value={target_attribute[Rules.OPERAND_ONE_VALUE_STATIC]} />
                        {
                            target_attribute.set_value_action === 'input' ?
                                this.valitdatorList.message('Value Static', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required|numeric') : null
                        }
                    </div>
                </div>
            }
            else if ((action !== 'set') && value_type === 'static') {
                return <div>
                    <div className="formLabel">Static Value Number</div>
                    <div>
                        <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} />
                        {
                            this.valitdatorList.message('Value Static', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required|numeric')
                        }
                    </div>
                </div>
            }
            else if (value_type === 'field') {
                return <div className="form-group">
                    <div className="formLabel">Value Attribute</div>
                    <Select
                        value={HF.returnTitleWithId(target_attribute[Rules.OPERAND_ONE_VALUE_FIELD_ID], this.props.location.state.attributesProp)}
                        name={Rules.OPERAND_ONE_VALUE_FIELD}
                        onChange={this.handleTargetDropdown}
                        options={this.props.location.state.attributesProp}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        className='text-capitalize'
                        isSearchable={true}
                        isMulti={false}
                        placeholder={'Choose Attribute'}
                        isClearable={false}
                    />
                    {
                        this.valitdatorList.message('Value Field', target_attribute[Rules.OPERAND_ONE_VALUE_FIELD], 'required')
                    }
                </div>
            }
            else if (value_type === 'lookup') {
                return <React.Fragment>
                    {
                        this.returnLookupTables(Rules.OPERAND_ONE_LOOKUP_TABLE, Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN)
                    }
                    {
                        this.state.target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN] &&
                        this.addLookupFilterTarget('operand_one_lookup', Rules.OPERAND_ONE_LOOKUP_TABLE)
                    }
                </React.Fragment>
            }
            else {
                return <div>
                    <div>
                        <span>
                            {/* <input type="text" onChange={this.targetInputHandler} name="value_static" /> */}
                        </span>
                    </div>
                </div>
            }
        }
        if (datatype === Rules.DATETIME && action !== undefined) {
            if (action === 'set' && value_type === 'static') {
                return <div>
                    <div>
                        {
                            this.returnStaticRadios()
                        }
                    </div>
                    <div>
                        <DatePicker
                            value={target_attribute[Rules.OPERAND_ONE_VALUE_STATIC]}
                            className="form-control"
                            onChange={(e) => this.handleTargetDateChange(Rules.OPERAND_ONE_VALUE_STATIC, e)}
                            placeholderText={`11/06/2019`}
                            disabled={target_attribute.set_value_action === 'input' ? false : true}
                        />
                        {
                            target_attribute.set_value_action === 'input' ?
                                this.valitdatorList.message('Value Static', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required') : null
                        }
                    </div>
                </div>
            }
            else if ((action.includes('add') || action.includes('subtract')) && value_type === 'static') {
                return <div>
                    <div className="formLabel">Static Value</div>
                    <div>
                        <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} />
                        {
                            this.valitdatorList.message('Value Static', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required|numeric')
                        }
                    </div>
                </div>
            }
            else if (value_type === 'field') {
                return <div className="form-group">
                    <div className="formLabel">Value Attribute</div>
                    <Select
                        value={HF.returnTitleWithId(target_attribute[Rules.OPERAND_ONE_VALUE_FIELD_ID], this.props.location.state.attributesProp)}
                        name={Rules.OPERAND_ONE_VALUE_FIELD}
                        onChange={this.handleTargetDropdown}
                        options={this.props.location.state.attributesProp}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        className='text-capitalize'
                        isSearchable={true}
                        isMulti={false}
                        placeholder={'Choose Attribute'}
                        isClearable={false}
                    />
                    {
                        this.valitdatorList.message('Value Field', target_attribute[Rules.OPERAND_ONE_VALUE_FIELD], 'required')
                    }
                </div>
            }
            else if (value_type === 'lookup') {

                return <React.Fragment>
                    {
                        this.returnLookupTables(Rules.OPERAND_ONE_LOOKUP_TABLE, Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN)
                    }
                    {
                        this.state.target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN] &&
                        this.addLookupFilterTarget('operand_one_lookup', Rules.OPERAND_ONE_LOOKUP_TABLE)
                    }
                </React.Fragment>
            }
            else {
                return <div>
                    <div>
                        <span>
                            {/* <input type="text" onChange={this.targetInputHandler} name="value_static" /> */}
                        </span>
                    </div>
                </div>
            }
        }
    }
    returnBaseTargetFields = (datatype, action, value_type, name) => {
        const { target_attribute, base_target_attribute } = this.state;
        if (name === 'row1') {
            if (action === 'set' && value_type === 'static') {
                return <div>
                    <div className="formLabel">Static Value</div>
                    <div>
                        <input type="text" className="form-control" onChange={this.targetInputHandler} name={Rules.OPERAND_ONE_VALUE_STATIC} value={target_attribute[Rules.OPERAND_ONE_VALUE_STATIC]} />
                        {
                            this.valitdatorList.message('Value Static', target_attribute[Rules.OPERAND_ONE_VALUE_STATIC], 'required')
                        }
                    </div>
                </div>
            }
            else if (value_type === 'field') {
                return <div className="form-group">
                    <div className="formLabel">Value Attribute</div>
                    <Select
                        value={HF.returnTitleWithId(target_attribute[Rules.OPERAND_ONE_VALUE_FIELD_ID], this.props.location.state.attributesProp)}
                        name={Rules.OPERAND_ONE_VALUE_FIELD}
                        onChange={this.handleBaseTargetDropdown}
                        options={this.props.location.state.attributesProp}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        className='text-capitalize'
                        isSearchable={true}
                        isMulti={false}
                        placeholder={'Choose Attribute'}
                        isClearable={false}
                    />
                    {
                        this.valitdatorList.message('Value Field', target_attribute[Rules.OPERAND_ONE_VALUE_FIELD], 'required')
                    }
                </div>
            }
            else if (value_type === 'lookup') {
                return <React.Fragment>
                    {
                        this.returnBaseLookupTables(Rules.OPERAND_ONE_LOOKUP_TABLE, Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN, 'target_attribute')
                    }
                    {
                        this.state.target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN] &&
                        this.addLookupFilterTarget('operand_one_lookup', Rules.OPERAND_ONE_LOOKUP_TABLE, 'target_attribute')
                    }
                </React.Fragment>
            }
            else {
                return <div>
                    <div>
                        <span>
                            {/* <input type="text" onChange={this.targetInputHandler} name="value_static" /> */}
                        </span>
                    </div>
                </div>
            }
        }

        else if (name === 'row2') {
            if (action === 'set' && value_type === 'static') {
                return <div>
                    <div className="formLabel">Static Value</div>
                    <div>
                        <input type="text" className="form-control" onChange={this.baseTargetInputHandler} name={Rules.OPERAND_TWO_VALUE_STATIC} value={base_target_attribute[Rules.OPERAND_TWO_VALUE_STATIC]} />
                        {

                            this.valitdatorList.message('Value Static', base_target_attribute[Rules.OPERAND_TWO_VALUE_STATIC], 'required|url')
                        }
                    </div>
                </div>
            }
            else if (value_type === 'field') {
                return <div className="form-group">
                    <div className="formLabel">Value Attribute</div>
                    <Select
                        value={HF.returnTitleWithId(base_target_attribute[Rules.OPERAND_TWO_VALUE_FIELD_ID], this.props.location.state.attributesProp)}
                        name={Rules.OPERAND_TWO_VALUE_FIELD}
                        onChange={this.handleBaseTargetDropdown}
                        options={this.props.location.state.attributesProp}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        className='text-capitalize'
                        isSearchable={true}
                        isMulti={false}
                        placeholder={'Choose Attribute'}
                        isClearable={false}
                    />
                    {
                        this.valitdatorList.message('Value Field', base_target_attribute[Rules.OPERAND_TWO_VALUE_FIELD], 'required')
                    }
                </div>
            }
            else if (value_type === 'lookup') {
                return <React.Fragment>
                    {
                        this.returnBaseLookupTables(Rules.OPERAND_TWO_LOOKUP_TABLE, Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN, 'base_target_attribute')
                    }
                    {
                        this.state.base_target_attribute[Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN] &&
                        this.addLookupFilterTarget('operand_two_lookup', Rules.OPERAND_TWO_LOOKUP_TABLE, 'base_target_attribute')
                    }
                </React.Fragment>
            }
            else {
                return <div>
                    <div>
                        <span>
                            {/* <input type="text" onChange={this.targetInputHandler} name="value_static" /> */}
                        </span>
                    </div>
                </div>
            }
        }
    }
    returnTargetValueTypes = (action) => {
        switch (action) {
            case 'add':
            case 'subtract':
            case 'multiply':
            case 'divide':
            case 'append':
            case 'prepend':
            case 'add day':
            case 'add month':
            case 'add year':
            case 'subtract day':
            case 'subtract month':
            case 'subtract year':
                return OC.DISABLED_TARGET_PARAM_TYPES;
            case 'set':
                return OC.TARGET_PARAM_TYPES;
            default:
                return [];
        }
    }

    concatComponent = (labelOne, labelTwo) => {
        const { target_attribute, concatAdditionalFields } = this.state;
        return <React.Fragment>
            <tr>
                <td width="11%" style={{ paddingBottom: '15px', verticalAlign: "top" }}>
                    <div className="form-group">
                        <div>
                            <div className="formLabel">{labelOne}</div>
                            <Select
                                value={HF.returnLabelWithValue(target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], OC.TARGET_PARAM_TYPES )}
                                onChange={this.handleTargetDropdown}
                                options={OC.CONCAT_PARAM_TYPES}
                                isSearchable={true}
                                name={Rules.OPERAND_ONE_VALUE_TYPE}
                                isMulti={false}
                                placeholder={'Choose Option'}
                                isClearable={false}
                            />
                            {this.valitdatorList.message(labelOne, target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], 'required')}
                        </div>
                    </div>
                </td>
                {
                    this.renderConditionalTargetFields()
                }
            </tr>
            {
                concatAdditionalFields.map((field, parentIndex) => <tr >
                    <td width="11%" test={console.log('parentIndex,', parentIndex)} style={{ paddingBottom: '15px', verticalAlign: "top" }}>
                        <div>
                            <div className="formLabel">{labelTwo }  </div>
                            <Select
                                value={HF.returnLabelWithValue(field.value_type, OC.TARGET_PARAM_TYPES)}
                                onChange={(e, name) => this.handleAdditionalConcatFields(parentIndex, e, name)}
                                options={OC.CONCAT_PARAM_TYPES}
                                isSearchable={true}
                                name={'value_type'}
                                isMulti={false}
                                placeholder={'Choose Option'}
                                isClearable={false}
                            />
                            {this.valitdatorList.message(labelTwo, field.value_type, 'required')}
                        </div>
                    </td>
                    <td>
                        <div style={{ position: 'relative' }}>
                            {
                                this.renderConditionalConcatFields(field, parentIndex)
                            }
                            {
                                concatAdditionalFields.length > 1 && field.value_type &&
                                <div className="removeFilterContainer">
                                    <OverlayTrigger
                                        placement="left"
                                        overlay={
                                            <Tooltip id="removeFilter">Remove Field</Tooltip>
                                        }>
                                        <span className="removeFilter" onClick={() => { this.removeConcatField(parentIndex) }}>
                                            <MdClose />
                                        </span>
                                    </OverlayTrigger>
                                </div>
                            }
                        </div>
                        {
                            parentIndex === concatAdditionalFields.length - 1 &&
                            <div style={{float: 'right', paddingTop: '10px'}}>
                                <button className="customBtn btnBlue btnRounded" onClick={this.addConcatField} disabled={!field.value_type}><IoMdAdd /></button>
                            </div>
                        }
                    </td>
                </tr>)
            }
        </React.Fragment>
    }


    renderConditionalConcatFields = (field, index) => {
        if (field) {
            if (field.value_type === 'static' || field.value_type === 'concatby') {
                return <div>
                    <div className="formLabel">
                        <label>
                             {field.value_type === 'static' ? 'Custom Value':'Enter Accurate Html Entity(s)'}
                        </label>
                    </div>
                    <div>
                        <input type="text" className="form-control" onChange={(e) => { this.additionalConcatInputHandler(e, index) }} name={'value_static'} value={field.value_static || ''} />
                        {
                            field.value_type === 'static' ?
                                this.valitdatorList.message('Static Value', field.value_static, 'required') : null
                        }
                    </div>
                </div>
            }

            // else if (field.value_type === 'concatby') {
                //      return <div className="form-group">
                //          <div className="formLabel">Select Concatenation Symbol</div>
                //          <Select
                //              // value={HF.returnLabelWithValue(brand_order_attributes.data_type, OC.dataTypeList)}
                //              name={'value_field'}
                //              onChange={(e, name) => this.additionalConcatDropdown(index, e, name)}
                //              options={[{id:"1",title:"Comma"},{id:"2",title:"Space"},{id:"3",title:"Tab"}]}
                //              getOptionLabel={(option) => option.title}
                //              getOptionValue={(option) => option.id}
                //              className='text-capitalize'
                //              isSearchable={true}
                //              isMulti={false}
                //              placeholder={'Choose Symbol'}
                //              isClearable={false}
                //          />
                //
                //      </div>
                //  }

            else if (field.value_type === 'field') {
                return <div className="form-group">
                    <div className="formLabel">Value Attribute</div>
                    <Select
                        // value={HF.returnLabelWithValue(brand_order_attributes.data_type, OC.dataTypeList)}
                        name={'value_field'}
                        onChange={(e, name) => this.additionalConcatDropdown(index, e, name)}
                        options={this.props.location.state.attributesProp}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        className='text-capitalize'
                        isSearchable={true}
                        isMulti={false}
                        placeholder={'Choose Attribute'}
                        isClearable={false}
                    />
                    {this.valitdatorList.message('Value Attribute', field.value_field, 'required')}
                </div>
            }
        }
    }

    additionalConcatInputHandler = (e, index) => {
        const { name, value } = e.target;
        const atts = [...this.state.concatAdditionalFields];
        atts[index][name] = value;
       // console.log(name,value)
        this.setState({
            concatAdditionalFields: atts,
        })

    }

    additionalConcatDropdown = (index, selectedOption, name) => {
        const atts = [...this.state.concatAdditionalFields];
        atts[index][name.name] = selectedOption.db_column,
            atts[index][name.name + '_title'] = selectedOption.title,
            atts[index][name.name + '_id'] = selectedOption.id
        this.setState({
            concatAdditionalFields: atts,
        }, () => {
          //  console.log('ccc', this.state.concatAdditionalFields);
        })
    }

    addConcatField = () => {
        const atts = [...this.state.concatAdditionalFields];
        atts.push({ ...OC.CONCAT_OBJ });
        this.setState({
            concatAdditionalFields: atts,
        })
    }

    removeConcatField = (index) => {
        const filters = [...this.state.concatAdditionalFields];
        const newArray = filters.filter((item, idx) => idx !== index);
        if (filters.length > 1)
            this.setState({
                concatAdditionalFields: newArray
            })
        else
            this.setState({
                concatAdditionalFields: [],
            })
    }

    returnTwoTargetValueTypeFields = (labelOne, labelTwo) => {

        const { target_attribute_data_type, target_attribute } = this.state;
     //   console.log('rep',target_attribute[Rules.OPERAND_ONE_ACTION])
        return <React.Fragment>
            <tr>
                <td width="11%" style={{ paddingBottom: '15px', verticalAlign: "top" }}>
                    <div className="form-group">
                        <div>
                            <div className="formLabel">{labelOne}</div>
                            <Select
                                value={HF.returnLabelWithValue(target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], OC.TARGET_PARAM_TYPES)}
                                onChange={this.handleTargetDropdown}

                                 options={(target_attribute_data_type === Rules.STRING || target_attribute_data_type === Rules.TEXT) ? (OC.TARGET_PARAM_TYPES).filter(type=>type.value!='concatby') : OC.DISABLED_DATE_PARAM_TYPES}
                                isSearchable={true}
                                name={Rules.OPERAND_ONE_VALUE_TYPE}
                                isMulti={false}
                                placeholder={'Choose Option'}
                                isClearable={false}
                            />
                            {this.valitdatorList.message(labelOne, target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], 'required')}
                        </div>
                    </div>
                </td>
                {
                    this.renderConditionalTargetFields()
                }
            </tr>
            <tr>
                <td width="11%" style={{ paddingBottom: '15px', verticalAlign: "top" }}>
                    <div>
                        <div className="formLabel">{labelTwo}</div>
                        <Select
                            value={HF.returnLabelWithValue(target_attribute[Rules.OPERAND_TWO_VALUE_TYPE], OC.TARGET_PARAM_TYPES)}
                            onChange={this.handleTargetDropdown}
                            options={(target_attribute_data_type === Rules.STRING || target_attribute_data_type === Rules.TEXT) ? (OC.TARGET_PARAM_TYPES).filter(type=>type.value!='concatby') : OC.DISABLED_DATE_PARAM_TYPES}
                            isSearchable={true}
                            name={Rules.OPERAND_TWO_VALUE_TYPE}
                            isMulti={false}
                            placeholder={'Choose Option'}
                            isClearable={false}
                        />
                        {this.valitdatorList.message(labelTwo, target_attribute[Rules.OPERAND_TWO_VALUE_TYPE], 'required')}
                    </div>
                </td>
                {
                    this.renderConditionalTargetFieldsOperandTwo()
                }
            </tr>
        </React.Fragment>
    }

    //function to return one or two target value fields depending upon the selected action and datatype
    returnTargetValueTypeField = (action) => {
        const { target_attribute } = this.state;
        switch (action) {
            case Rules.REPLACE:
                return this.returnTwoTargetValueTypeFields('Search String Value Type', 'Replace String Value Type')
            case Rules.CONCAT:
                return this.concatComponent('Select First Parameter', 'Select Next Parameter')
            case Rules.MULTIPLY:
            case Rules.DIVIDE:
            case Rules.SUBTRACT:
            case Rules.ADD:
                return this.returnTwoTargetValueTypeFields('Operand 1 Value Type', 'Operand 2 Value Type')
            default:
                return <tr>
                    <td width="11%" style={{ paddingBottom: '15px', verticalAlign: "top" }}>
                        <div>
                            <div className="formLabel">Value Type</div>
                            <Select
                                value={HF.returnLabelWithValue(target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], OC.TARGET_PARAM_TYPES)}
                                onChange={this.handleTargetDropdown}
                                options={this.returnTargetValueTypes(target_attribute[Rules.OPERAND_ONE_ACTION])}
                                isSearchable={true}
                                name={Rules.OPERAND_ONE_VALUE_TYPE}
                                isMulti={false}
                                placeholder={'Choose Option'}
                                isClearable={false}
                            />
                            {this.valitdatorList.message('Value Type', target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], 'required')}
                        </div>
                    </td>
                    {
                        this.renderConditionalTargetFields()
                    }
                </tr>

        }

    }
    returnBaseTargetValueTypeFields = (action, name, value_type) => {
        const { target_attribute, base_target_attribute } = this.state;
        return value_type.includes('operand_two') ?
            <div >
                <div className="formLabel">Value Type</div>
                <Select
                    value={HF.returnLabelWithValue(base_target_attribute[value_type], OC.TARGET_PARAM_TYPES)}
                    onChange={this.handleBaseTargetDropdown}
                    options={this.returnTargetValueTypes(base_target_attribute[name])}
                    isSearchable={true}
                    name={value_type}
                    isMulti={false}
                    placeholder={'Choose Option'}
                    isClearable={false}
                />
                {this.valitdatorList.message('Value Type', base_target_attribute[value_type], 'required')}
            </div>
            :
            <div >
                <div className="formLabel">Value Type</div>
                <Select
                    value={HF.returnLabelWithValue(target_attribute[value_type], OC.TARGET_PARAM_TYPES)}
                    onChange={this.handleBaseTargetDropdown}
                    options={this.returnTargetValueTypes(target_attribute[name])}
                    isSearchable={true}
                    name={value_type}
                    isMulti={false}
                    placeholder={'Choose Option'}
                    isClearable={false}
                />
                {this.valitdatorList.message('Value Type', target_attribute[value_type], 'required')}
            </div>
    }

    renderConditionalTargetFields = () => {
        const { target_attribute, target_attribute_data_type } = this.state;
      //  console.log("target",target_attribute)

        if (target_attribute[Rules.OPERAND_ONE_ACTION] === 'replace') {
            return <td width="50%" style={{ verticalAlign: "top" }}>
                {
                    this.returnReplaceTargetFields(target_attribute_data_type, target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], 'search_string_type')
                }
            </td>
        }

        else if (target_attribute[Rules.OPERAND_ONE_ACTION] === Rules.CONCAT) {
            return <td width="50%" style={{ verticalAlign: "top" }}>
                {

                    this.returnConcatFields(target_attribute_data_type, target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], 'first_operand')
                }
            </td>
        }

        else if (target_attribute[Rules.OPERAND_ONE_ACTION] === 'multiply' || target_attribute[Rules.OPERAND_ONE_ACTION] === 'divide' || target_attribute[Rules.OPERAND_ONE_ACTION] === 'add' || target_attribute[Rules.OPERAND_ONE_ACTION] === 'subtract') {
            return <td width="50%" style={{ verticalAlign: "top" }}>
                {
                    this.returnReplaceTargetFields(target_attribute_data_type, target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], Rules.OPERAND_ONE_VALUE_TYPE)
                }
            </td>
        }

        else {
            // Insert the old fiels down here
            return <td width="50%" style={{ verticalAlign: "top" }}>
                {this.returnTargetFields(target_attribute_data_type, target_attribute[Rules.OPERAND_ONE_ACTION], target_attribute[Rules.OPERAND_ONE_VALUE_TYPE])}
            </td>
        }
    }

    renderConditionalTargetFieldsOperandTwo = () => {
        const { target_attribute, target_attribute_data_type } = this.state;

        if (target_attribute[Rules.OPERAND_ONE_ACTION] === 'replace') {
            return <td width="50%" style={{ verticalAlign: "top" }}>
                {
                    this.returnReplaceTargetFields(target_attribute_data_type, target_attribute[Rules.OPERAND_TWO_VALUE_TYPE], 'replace_string_type')
                }
            </td>
        }

        else if (target_attribute[Rules.OPERAND_ONE_ACTION] === 'multiply' || target_attribute[Rules.OPERAND_ONE_ACTION] === 'divide' || target_attribute[Rules.OPERAND_ONE_ACTION] === 'add' || target_attribute[Rules.OPERAND_ONE_ACTION] === 'subtract') {
            return <td width="50%" style={{ verticalAlign: "top" }}>
                {
                    this.returnReplaceTargetFields(target_attribute_data_type, target_attribute[Rules.OPERAND_TWO_VALUE_TYPE], Rules.OPERAND_TWO_VALUE_TYPE)
                }
            </td>
        }
        else {
            // Insert the old fiels down here
            return <td width="50%" style={{ verticalAlign: "top" }}>
                {this.returnTargetFields(target_attribute_data_type, target_attribute[Rules.OPERAND_ONE_ACTION], target_attribute[Rules.OPERAND_ONE_VALUE_TYPE])}
            </td>
        }
    }

    componentDidMount() {
        $("html, body").animate({ scrollTop: 0 }, 300, "linear");
        if (this.props.location.state !== undefined) {
            const { targetAttribute } = this.props.location.state;
            if (targetAttribute) {
                this.setState({
                    ...this.state,
                    target_attribute: {
                        ...this.state.target_attribute,
                        target_attribute_id: targetAttribute.id,
                        target_attribute: targetAttribute.db_column,
                        target_attribute_title: targetAttribute.title,
                    },
                    target_attribute_data_type: targetAttribute.data_type,
                    lookupTable: this.props.location.state.lookupTables,
                    lookupAttributes: this.props.location.state.lookupAttributes,
                    attributesLookup: this.props.location.state.attributesLookup,
                }, () => {
                    if (this.state.target_attribute_data_type === 'url') {
                        this.setState({
                            ...this.state,
                            target_attribute: {
                                ...this.state.target_attribute,
                                [Rules.OPERAND_ONE_ACTION]: 'set'
                            },
                            base_target_attribute: {
                                ...this.state.base_target_attribute,
                                [Rules.OPERAND_TWO_ACTION]: 'set'
                            }
                        })
                    }
                })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(this.state.rule_filters, prevState.rule_filters)) {
            let start = 0;
            let end = 0;
            let sum = 0;
            this.state.rule_filters.forEach((item, index) => {
                start += item.parenthesis_start.length;
                end += item.parenthesis_end.length;
            })
            sum = start - end;
            if (sum < 0 && !this.state.paren_unequal) {
                this.setState({
                    ...this.state,
                    paren_unequal: true,
                    totalParen: false,
                    disableAddFilter: true,
                })
            }
            if (sum >= 0 && this.state.paren_unequal) {
                this.setState({
                    ...this.state,
                    paren_unequal: false,
                    totalParen: false,
                    disableAddFilter: false,
                })
            }
            if (sum <= 0 && this.state.totalParen) {
                this.setState({
                    totalParen: false
                })
            }
        }
    }

    returnOperandsArray = (operands_object) => {
        const { operand_one, operand_one_type, operand_two, operand_two_type, operand_one_title = null, operand_two_title = null, operand_one_lookup_expression = [], operand_two_lookup_expression = [] } = operands_object;
        const operands = [];
        if (operand_one) {
            operands.push(
                {
                    type: operand_one_type,
                    value: operand_one,
                    title: operand_one_title,
                    lookup_filters: operand_one_lookup_expression,
                }
            )
        }
        if (operand_two) {
            operands.push(
                {
                    type: operand_two_type,
                    value: operand_two,
                    title: operand_two_title,
                    lookup_filters: operand_two_lookup_expression,
                }
            )
        }
        return operands
    }

    returnExpressionObject = (complete_object) => {
        const { operand_one, operand_one_type, action_one, operand_two, operand_two_type, action_two, operand_one_title, operand_two_title, operand_one_lookup_expression, operand_two_lookup_expression } = complete_object;
        const expression = [];
        if (action_two) {
            expression.push(
                {
                    operator: action_one,
                    operands: this.returnOperandsArray({
                        operand_one: operand_one,
                        operand_one_type: operand_one_type,
                        operand_two: '',
                        operand_two_type: '',
                        operand_one_title: operand_one_title,
                        operand_one_lookup_expression: operand_one_lookup_expression,
                    })
                }
            )
            expression.push(
                {
                    operator: action_two,
                    operands: this.returnOperandsArray({
                        operand_one: '',
                        operand_one_type: '',
                        operand_two: operand_two,
                        operand_two_type: operand_two_type,
                        operand_one_title: '',
                        operand_two_title: operand_two_title,
                        operand_two_lookup_expression: operand_two_lookup_expression,
                    })
                }
            )
        }
        else {
            expression.push(
                {
                    operator: action_one,
                    operands: this.returnOperandsArray({
                        operand_one: operand_one,
                        operand_one_type: operand_one_type,
                        operand_two: operand_two,
                        operand_two_type: operand_two_type,
                        operand_one_title: operand_one_title,
                        operand_two_title: operand_two_title,
                        operand_one_lookup_expression: operand_one_lookup_expression,
                        operand_two_lookup_expression: operand_two_lookup_expression,
                    })
                }
            )
        }
        return expression;
    }

    appendOperandTwoWithExpression = (expression_object) => {

        const { target_attribute, operand_one, operand_one_type, action_one, action_two, operand_one_title, operand_two_title, operand_one_lookup_expression, operand_two_lookup_expression } = expression_object;

        //WORKK ON ADDING TITLES

        // const { target_attribute, target_attribute_data_type } = this.state;
        let expression = [];
        expression = this.returnExpressionObject({
            operand_one: operand_one,
            operand_one_type: operand_one_type,
            action_one: action_one,
            operand_two: '',
            operand_two_type: '',
            action_two: '',
            operand_one_title: operand_one_title,
            operand_one_lookup_expression: operand_one_lookup_expression,
        });
        if (target_attribute[Rules.OPERAND_TWO_VALUE_STATIC]) {
            expression = this.returnExpressionObject(
                {
                    operand_one: operand_one,
                    operand_one_type: operand_one_type,
                    action_one: action_one,
                    operand_two: [target_attribute[Rules.OPERAND_TWO_VALUE_STATIC]],
                    operand_two_type: target_attribute[Rules.OPERAND_TWO_VALUE_TYPE],
                    action_two: action_two,
                    operand_one_title: operand_one_title,
                    operand_one_lookup_expression: operand_one_lookup_expression,
                }
            )
        }

        else if (target_attribute[Rules.OPERAND_TWO_VALUE_TYPE] === 'static') {
            expression = this.returnExpressionObject(
                {
                    operand_one: operand_one,
                    operand_one_type: operand_one_type,
                    action_one: action_one,
                    operand_two: [
                        target_attribute[Rules.OPERAND_TWO_VALUE_STATIC]
                    ],
                    operand_two_type: target_attribute[Rules.OPERAND_TWO_VALUE_TYPE],
                    action_two: action_two,
                    operand_one_title: operand_one_title,
                    operand_one_lookup_expression: operand_one_lookup_expression,
                }
            );

        }

        else if (target_attribute[Rules.OPERAND_TWO_VALUE_FIELD]) {
            expression = this.returnExpressionObject(
                {
                    operand_one: operand_one,
                    operand_one_type: operand_one_type,
                    action_one: action_one,
                    operand_two: [target_attribute[Rules.OPERAND_TWO_VALUE_FIELD]],
                    operand_two_type: target_attribute[Rules.OPERAND_TWO_VALUE_TYPE],
                    action_two: action_two,
                    operand_one_title: operand_one_title,
                    operand_two_title: target_attribute[Rules.OPERAND_TWO_VALUE_FIELD_TITLE],
                    operand_one_lookup_expression: operand_one_lookup_expression,
                }
            )
        }

        else if (target_attribute[Rules.OPERAND_TWO_LOOKUP_TABLE]) {

            expression = this.returnExpressionObject(
                {
                    operand_one: operand_one,
                    operand_one_type: operand_one_type,
                    action_one: action_one,
                    operand_two: [
                        target_attribute[Rules.OPERAND_TWO_LOOKUP_TABLE],
                        target_attribute[Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN]
                    ],
                    operand_two_type: target_attribute[Rules.OPERAND_TWO_VALUE_TYPE],
                    action_two: action_two,
                    operand_one_title: operand_one_title,
                    operand_two_title: target_attribute[Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN_TITLE],
                    operand_one_lookup_expression: operand_one_lookup_expression,
                    operand_two_lookup_expression: this.state.operand_two_lookup_expression,
                }
            )
        }
        return expression
    }


    createTargetExpression = () => {
        const { concatAdditionalFields, target_attribute, base_target_attribute, target_attribute_data_type } = this.state;
        if (target_attribute_data_type !== 'url') {
            const action_one = target_attribute[Rules.OPERAND_ONE_ACTION]
            let expressionArray;

            //? FOR NEW OPERATOR CONCATENATION
            if (action_one === Rules.CONCAT) {
                console.log('ok',target_attribute)
                let tempObj = {};

                tempObj.operator = action_one;
                let val1='';

                if(target_attribute[Rules.OPERAND_ONE_VALUE_TYPE] === 'static'|| target_attribute[Rules.OPERAND_ONE_VALUE_TYPE] === 'concatby' ){
                    val1=[target_attribute[Rules.OPERAND_ONE_VALUE_STATIC]]
                } else {
                    val1=  [target_attribute[Rules.OPERAND_ONE_VALUE_FIELD]]
                }

                let operands = [{
                    type: target_attribute[Rules.OPERAND_ONE_VALUE_TYPE],
                    value:  val1,
                    title: target_attribute[Rules.OPERAND_ONE_VALUE_TYPE] === 'field' ? target_attribute[Rules.OPERAND_ONE_VALUE_FIELD_TITLE] : ''
                }]
                concatAdditionalFields.forEach(field => {
                    let val2='';
                    if(field['value_type'] === 'static' || field['value_type'] === 'concatby'){

                        val2=[field['value_static']]
                    }
                    else
                    {
                        val2=[field['value_field']]
                    }
                    operands.push({
                        type: field['value_type'],
                        value: val2,
                        title: field['value_type'] === 'field' ? field['value_field_title']: ''
                    })
                })
                tempObj.operands = [...operands];
                expressionArray = [{ ...tempObj }];
            }

            else if (target_attribute[Rules.OPERAND_ONE_VALUE_STATIC]) {

                expressionArray = this.appendOperandTwoWithExpression(
                    {
                        target_attribute: target_attribute,
                        operand_one: [
                            target_attribute[Rules.OPERAND_ONE_VALUE_STATIC]
                        ],
                        operand_one_type: target_attribute[Rules.OPERAND_ONE_VALUE_TYPE],
                        action_one: action_one
                    }
                );

            }

            else if (target_attribute[Rules.OPERAND_ONE_VALUE_TYPE] === 'static') {
                expressionArray = this.appendOperandTwoWithExpression(
                    {
                        target_attribute: target_attribute,
                        operand_one: [
                            target_attribute[Rules.OPERAND_ONE_VALUE_STATIC]
                        ],
                        operand_one_type: target_attribute[Rules.OPERAND_ONE_VALUE_TYPE],
                        action_one: action_one
                    }
                );

            }
            else if (target_attribute[Rules.OPERAND_ONE_VALUE_FIELD]) {

                expressionArray = this.appendOperandTwoWithExpression(
                    {
                        target_attribute: target_attribute,
                        operand_one: [
                            target_attribute[Rules.OPERAND_ONE_VALUE_FIELD]
                        ],
                        operand_one_type: target_attribute[Rules.OPERAND_ONE_VALUE_TYPE],
                        action_one: action_one,
                        action_two: '',
                        operand_one_title: target_attribute[Rules.OPERAND_ONE_VALUE_FIELD_TITLE]
                    }
                );

            }
            else if (target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE]) {
                expressionArray = this.appendOperandTwoWithExpression(
                    {
                        target_attribute: target_attribute,
                        operand_one: [
                            target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE],
                            target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN]
                        ],
                        operand_one_type: target_attribute[Rules.OPERAND_ONE_VALUE_TYPE],
                        action_one: action_one,
                        action_two: '',
                        operand_one_title: target_attribute[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN_TITLE],
                        operand_one_lookup_expression: this.state.operand_one_lookup_expression,
                    }
                );
            }
            return expressionArray;
        }
        else if (target_attribute_data_type === 'url') {
            const action_one = target_attribute[Rules.OPERAND_ONE_ACTION]
            const merged_target = { ...target_attribute, ...base_target_attribute }
            let expressionArray;
            if (merged_target[Rules.OPERAND_ONE_VALUE_STATIC]) {
                expressionArray = this.appendOperandTwoWithExpression(
                    {
                        target_attribute: merged_target,
                        operand_one: [
                            merged_target[Rules.OPERAND_ONE_VALUE_STATIC]
                        ],
                        operand_one_type: merged_target[Rules.OPERAND_ONE_VALUE_TYPE],
                        action_one: action_one,
                        action_two: merged_target[Rules.OPERAND_TWO_ACTION]
                    }
                );

            }
            else if (merged_target[Rules.OPERAND_ONE_VALUE_FIELD]) {

                expressionArray = this.appendOperandTwoWithExpression(
                    {
                        target_attribute: merged_target,
                        operand_one: [
                            merged_target[Rules.OPERAND_ONE_VALUE_FIELD]
                        ],
                        operand_one_type: merged_target[Rules.OPERAND_ONE_VALUE_TYPE],
                        action_one: action_one,
                        action_two: merged_target[Rules.OPERAND_TWO_ACTION],
                        operand_one_title: merged_target[Rules.OPERAND_ONE_VALUE_FIELD_TITLE]
                    }
                );

            }
            else if (merged_target[Rules.OPERAND_ONE_LOOKUP_TABLE]) {

                expressionArray = this.appendOperandTwoWithExpression(
                    {
                        target_attribute: merged_target,
                        operand_one: [
                            merged_target[Rules.OPERAND_ONE_LOOKUP_TABLE],
                            merged_target[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN]
                        ],
                        operand_one_type: merged_target[Rules.OPERAND_ONE_VALUE_TYPE],
                        action_one: action_one,
                        action_two: merged_target[Rules.OPERAND_TWO_ACTION],
                        operand_one_title: merged_target[Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN_TITLE],
                        operand_one_lookup_expression: this.state.operand_one_lookup_expression,
                    }
                );
            }
            return expressionArray;
        }
    }

    createRuleFiltersExpressions = (rule_filters) => {
        let expressionArray = [];
        const actionFiltersArray = rule_filters.map((rule, index) => {
            if (rule.param_type === 'static') {
                if (Array.isArray(rule.param_static_value)) {
                    rule.param_value = rule.param_static_value;
                }
                else {
                    rule.param_value = [rule['param_static_value']];
                }
            }
            else if (rule.param_type === 'field') {
                rule.param_value = [rule['param_field']];
                rule.param_title = rule.param_field_title;
            }
            else if (rule.param_type === 'lookup') {
                rule.param_value = [rule['param_lookup_table'], rule['param_lookup_table_column']];
                rule.param_title = rule.param_lookup_table_column_title;
            }
            else if (rule.operator === 'empty') {
                rule.param_value = ['']
                rule.param_type = 'static';
            }
            rule.actions = expressionArray;
            return rule;
        })
        return actionFiltersArray;
    }
    render() {
        this.valitdatorList.purgeFields();
        const { target_attribute, base_target_attribute, rule_filters, target_attribute_data_type } = this.state;
        return (<Grid fluid>
            <Row>
                <Col md={12}>
                    <Card
                        ctTableResponsive
                        content={
                            <div>
                                <Grid fluid>
                                    <Row>
                                        <Col md={12}>
                                            <form className="transformationRules" onSubmit={this.handleListSubmitForm}>
                                                <h3>Transformation Rules for <b>{this.props.location.state.targetAttribute.title}</b> Attribute</h3>
                                                {
                                                    target_attribute_data_type !== 'url' &&
                                                    <React.Fragment>
                                                        <div className="flexElem rulesTitleContainer">
                                                            <h4 className="mt-none" style={{ color: '#1684e4', whiteSpace: 'nowrap' }}>
                                                                Set
                                                            </h4>

                                                            <div className="flexElem">
                                                                <div className="formLabel">Actions</div>
                                                                <div>
                                                                    <Select
                                                                        value={HF.returnLabelWithValue(this.state.target_attribute[Rules.OPERAND_ONE_ACTION], this.state.target_attribute_data_type ? this.returnActionsList(this.state.target_attribute_data_type) : [])}
                                                                        onChange={this.handleTargetDropdown}
                                                                        options={target_attribute_data_type ? this.returnActionsList(target_attribute_data_type) : []}
                                                                        isSearchable={true}
                                                                        name={Rules.OPERAND_ONE_ACTION}
                                                                        isMulti={false}
                                                                        className="text-capitalize"
                                                                        placeholder={'Choose Action'}
                                                                        isClearable={false}
                                                                    />
                                                                    {this.valitdatorList.message('Attribute', target_attribute[Rules.OPERAND_ONE_ACTION], 'required')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <table className="table blank mt-xlg">
                                                            <tbody>
                                                                {
                                                                    this.returnTargetValueTypeField(target_attribute[Rules.OPERAND_ONE_ACTION])
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </React.Fragment>
                                                }

                                                {
                                                    target_attribute_data_type === 'url' &&
                                                    <React.Fragment>
                                                        <div className="flexElem rulesTitleContainer">
                                                            <h4 className="mt-none" style={{ color: '#1684e4', whiteSpace: 'nowrap' }}>
                                                                Set URL Title
                                                            </h4>

                                                            <div className="flexElem">
                                                                <div className="formLabel">Actions</div>
                                                                <div>
                                                                    <Select
                                                                        value={HF.returnLabelWithValue(this.state.target_attribute[Rules.OPERAND_ONE_ACTION], this.state.target_attribute_data_type ? this.returnActionsList(this.state.target_attribute_data_type) : [])}
                                                                        onChange={this.handleBaseTargetDropdown}
                                                                        options={target_attribute_data_type ? this.returnActionsList(target_attribute_data_type) : []}
                                                                        isSearchable={true}
                                                                        name={Rules.OPERAND_ONE_ACTION}
                                                                        isMulti={false}
                                                                        className="text-capitalize"
                                                                        placeholder={'Choose Action'}
                                                                        isClearable={false}
                                                                    />
                                                                    {this.valitdatorList.message('Attribute', target_attribute[Rules.OPERAND_ONE_ACTION], 'required')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <table className="table blank mt-xlg">
                                                            <tbody>
                                                                <tr>
                                                                    <td width="11%" style={{ paddingBottom: '15px', verticalAlign: "top" }}>
                                                                        {
                                                                            this.returnBaseTargetValueTypeFields(target_attribute[Rules.OPERAND_ONE_ACTION], Rules.OPERAND_ONE_ACTION, Rules.OPERAND_ONE_VALUE_TYPE)
                                                                        }
                                                                    </td>
                                                                    <td width="50%" style={{ verticalAlign: "top" }}>
                                                                        {
                                                                            this.returnBaseTargetFields(target_attribute_data_type, target_attribute[Rules.OPERAND_ONE_ACTION], target_attribute[Rules.OPERAND_ONE_VALUE_TYPE], 'row1')
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        {/*


                                                                    this is the 2nd ROw

                                                                    */}
                                                        <hr />
                                                        <div className="flexElem rulesTitleContainer">
                                                            <h4 className="mt-none" style={{ color: '#1684e4', whiteSpace: 'nowrap' }}>
                                                                Set URL
                                                            </h4>

                                                            <div className="flexElem">
                                                                <div className="formLabel">Actions</div>
                                                                <div>
                                                                    <Select
                                                                        value={HF.returnLabelWithValue(this.state.base_target_attribute[Rules.OPERAND_TWO_ACTION], this.state.target_attribute_data_type ? this.returnActionsList(this.state.target_attribute_data_type) : [])}
                                                                        onChange={this.handleBaseTargetDropdown}
                                                                        options={target_attribute_data_type ? this.returnActionsList(target_attribute_data_type) : []}
                                                                        isSearchable={true}
                                                                        name={Rules.OPERAND_TWO_ACTION}
                                                                        isMulti={false}
                                                                        className="text-capitalize"
                                                                        placeholder={'Choose Action'}
                                                                        isClearable={false}
                                                                    />
                                                                    {this.valitdatorList.message('Action', base_target_attribute[Rules.OPERAND_TWO_ACTION], 'required')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <table className="table blank mt-xlg">
                                                            <tbody>
                                                                <tr>
                                                                    <td width="11%" style={{ paddingBottom: '15px', verticalAlign: "top" }}>
                                                                        {
                                                                            this.returnBaseTargetValueTypeFields(base_target_attribute[Rules.OPERAND_TWO_ACTION], Rules.OPERAND_TWO_ACTION, Rules.OPERAND_TWO_VALUE_TYPE)
                                                                        }
                                                                    </td>

                                                                    <td width="50%" style={{ verticalAlign: "top" }}>
                                                                        {
                                                                            this.returnBaseTargetFields(target_attribute_data_type, base_target_attribute[Rules.OPERAND_TWO_ACTION], base_target_attribute[Rules.OPERAND_TWO_VALUE_TYPE], 'row2')
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </React.Fragment>
                                                }

                                                <hr />
                                                {
                                                    rule_filters.length > 0 &&
                                                    <div style={{ position: 'relative' }}>
                                                        <h4 className="mt-none" style={{ color: '#1684e4' }}>
                                                            {(target_attribute.value_lookup_table && target_attribute.value_lookup_table_column) || ((target_attribute.search_lookup_table && target_attribute.search_lookup_table_column)) ? 'How to lookup / filter matching records' : 'IF'}
                                                        </h4>
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <td width="5%">Not</td>
                                                                    <td width="7%">Parens *</td>
                                                                    <td width="13%">Attribute *</td>
                                                                    <td>Operator *</td>
                                                                    <td width="13%">Param Type *</td>
                                                                    <td width="8%">Param (s)*</td>
                                                                    <td width="15%">Description*</td>
                                                                    <td width="7%">Parens *</td>
                                                                    <td>AND/OR *</td>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {
                                                                    this.createTable(rule_filters)
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                }

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className='text-center'>
                                                            <button className="customBtn m-md btnBlack" type='button' onClick={() => { this.props.history.goBack() }} >Go Back</button>
                                                            <button className="customBtn m-md btnBlue">Save Rule</button>
                                                            <button className="customBtn m-md btnBlack" onClick={this.handleAddFilter} disabled={this.state.disableAddFilter}>Add Filter</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </Col>
                                    </Row>
                                </Grid>
                            </div>
                        }
                    />
                </Col>
            </Row>
        </Grid>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        storeTransformationRulesCall: (data, id) => { return dispatch(brandActions.storeTransformationRules(data, id)) }
    });
};
function mapStateToProps(state) {
    const { storedRule } = state.brandReducer;
    return {
        storedRule,
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TransformationRulesForm));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/TransformationRulesForm.jsx